import React, { useContext, useEffect, useRef, useState } from 'react'
import GenericFormComponent from '../../../genericComponents/forms/GenericFormComponent'
import { allowOnlyNumbers, parseJwt, scrollIntoViewIfNeeded, uptoTwoDecimalRegex } from '../../../helper/genericFunction'
import { dispatchHandler, handleApiChange, validateMobileNumber, validateNumber } from '../../../helper/apiHelperFunctions';
import { useDispatch, useSelector } from 'react-redux';
import Icons from '../../../assets/icons';
import dayjs from 'dayjs';
import GenericTabsComponent from '../../../genericComponents/GenericTabsComponent';
import ParentModal from '../../../genericComponents/ParentModal';
import useCustomToast from '../../../hooks/useCustomToast';
import AddSku from './AddSku';
import LineItemDetailsTab from './LineItemDetailsTab';
import CreateBoxTab from './CreateBoxTab';
import { Switch, Tooltip } from 'antd';
import GenericConfirmationModal from '../../../genericComponents/GenericConfiramationModal';
import ScanNPackModal from './ScanNPackModal';
import readXlsxFile from 'read-excel-file';
import { v4 as uuidv4 } from 'uuid';
import GenericCustomButton from '../../../genericComponents/GenericCustomButton';
import ManageAddress from './components/ManageAddress';
import LanguageTranslator from '../../../locals/LanguageTranslator';
import { ReloadContext } from '../../../App';
import { getPermissionKey } from '../../../helper/permissions';
import MultipleAsnSubmissionModal from './components/MultipleAsnSubmissionModal';
import { ChevronDown, ClipboardList, EyeOff, FileCheck, HandCoins, Icon, Info, SquarePen, Trash2, TriangleAlert } from 'lucide-react';
import GenericDeleteModal from '../../../genericComponents/helperComponents/GenericDeleteModal';
import { getCurrentDateFormat, getHeadersType, modifyDataForDocumentViewerUrlInsertion, translateObjectValues } from '../../../helper/helperTableFunctions';
import GenericMediaViewModal from '../../../genericComponents/media/GenericMediaViewModal';
import CreateBoxTemplateDropdown from './components/CreateBoxTemplateDropdown';
import EditBoxIdModal from './components/EditBoxIdModal';
import GenericSpinnerLoader from '../../../loaders/GenericSpinnerLoader';
import FileUpload from '../../../genericComponents/filesUpload/FileUpload';
import { displayNamesForNewSubmitApi } from '../../../genericComponents/oldGenericComponents/tableHelperComponents/DisplayNameForNewServer';
import { CONFIG } from '../../../config';
import '../../../styles/stylesheets/DigiVend/DigiVend.scss'
import GenericInput from '../../../genericComponents/input/GenericInputComponent';
import { getPayloadFromURLParams, setPayloadAsURLParams } from '../../../helper/URLParamsHelper';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
// import utc from "dayjs/plugin/utc";
// dayjs.extend(utc);

function CreateAsnModal(props) {

    const { bootConfig } = useContext(ReloadContext)

    let boxIDCount = 0;

    const { vendConfig, modalHeading, closeModalV2 = null, isEdit, headerKey, prevParams = {} } = props;
    const digiVendStore = useSelector(state => state.digivendStore);
    const generalStore = useSelector(state => state.generalStore);
    const getDigicatFormSettingsData = useSelector(state => state?.administrationStore?.getDigicatFormSettingsData);
    const dispatch = useDispatch();

    const customToast = useCustomToast();
    const [selectedData, setSelectedData] = useState(props?.selectedData)
    const [formData, setFormData] = useState({});
    const [errorData, setErrorData] = useState({})
    const [currentTab, setCurrentTab] = useState("lineItemDetails");
    const [headersType, setHeadersType] = useState("");
    const [headersData, setHeadersData] = useState({});
    const [poDetails, setPoDetails] = useState([]);
    const [expandedSetRow, setExpandedSetRow] = useState(false);
    const [itemRowData, setItemRowData] = useState([]);
    const [poDetailsSearchValue, setPoDetailsSearchValue] = useState("");
    const [openedModal, setOpenedModal] = useState(false);
    const [callAfterExcelUpload, setCallAfterExcelUpload] = useState(false);
    const [uuId, setUuId] = useState("");
    const [callAutoInvoiceAmount, setCallAutoInvoiceAmount] = useState({ funCall: true })
    const [callErrroValidationFun, setcallErrroValidationFun] = useState(false)
    const [asnSummary, setAsnSummary] = useState({})
    const [showHoldAsnDropdown, setShowHoldAsnDropdown] = useState(false);
    const [state, setState] = useState({
        mixedBoxesAllowedInThisPo: false,
        boxCreation: false,
        addSKUModal: -1,
        skuBoxesWeightWise: [],
        weightMandatory: vendConfig?.CAPTURE_WEIGHT_SKU_LEVEL,
        lbhMandatory: vendConfig?.CAPTURE_LBH_SKU_LEVEL,
        fixedTotalBoxCount: vendConfig?.FIXED_TOTAL_BOX_COUNT?.toLowerCase() === "true" ? true : false,
        mixedSKUAllowedUpto: vendConfig?.MIXED_SKU_CONFIG,
        mixedBoxesAllowed: (vendConfig?.MIXED_SKU_CONFIG == "0" || vendConfig?.MIXED_SKU_CONFIG == "") ? false : true,
        mixedSKUPerBox: vendConfig?.MIXED_SKU_PER_BOX?.toLowerCase() === "true",
        noOfSKUPerBox: {},
        emptyCartonWeight: "",
        overallRequestedQtyError: "",
        boxPrefix: isEdit ? selectedData?.boxPrefix : "",
        boxTemplate: null,
    });
    const [isAllQtyZero, setIsAllQtyZero] = useState(isEdit ? false : vendConfig?.ZERO_QTY_ASN_FORM_INITIALISATION || true ? true : false)
    const [callConfirmatioFun, setCallConfirmatioFun] = useState(false)
    const [skuWiseBoxes, setSkuWiseBoxes] = useState({});
    const [boxes, setBoxes] = useState([])
    const [callBackFun, setCallBackFun] = useState({ funName: "", value: "" })
    const [formSettings, setFormSettings] = useState({})

    // state:  to store the local dropdown data here
    const [localDropdownData, setLocalDropdownData] = useState({});

    // State : To store the local drafted asn data
    const [draftedAsnData, setDraftedAsnData] = useState({});
    const [currentDraftAsnIndex, setCurrentDraftAsnIndex] = useState(-1);
    const [poDetailsResponse, setPoDetailsResponse] = useState(null);
    const [resetDataForDraftAsn, setResetDataForDraftAsn] = useState(false);

    // State: To store show confirmation modal
    const [confirmationModalShow, setConfirmationModalShow] = useState(false);

    // State: To store show asn dropdown data here
    const [showDraftedAsnDropdown, setShowDraftedAsnDropdown] = useState(false);
    const [draftAsnMaxKey, setDraftAsnMaxKey] = useState(`Draft-1`)

    const [initalSkuWiseBoxesData, setInitialSkuWiseBoxesData] = useState(null);
    const [currentShipmentTypeData, setCurrentShipmentTypeData] = useState(isEdit ? "calculating" : null);
    const [backupShipmentTypeData, setBackupShipmentTypeData] = useState(null)

    // state to store get images data
    const [uploadedFileDirectory, setUploadedFileDirectory] = useState({});
    const [getImagesOf, setGetImagesOf] = useState("");
    const [updateImageState, setUpdateImageState] = useState(false);

    const [modalData, setModalData] = useState({})
    const [editresponse, setEditResponse] = useState(null);

    const [checkEligibleASN, setCheckEligibleASN] = useState(false);
    const [originalPoDetails, setOriginalPoDetails] = useState([]);
    const [anyPoOnHold, setAnyPoOnHold]= useState(false);

    // State: To track acceptance of the late delivery charge (only applicable while creating)
    const [lateDeliveryChargeAccepted, setLateDeliveryChargeAccepted] = useState(false);

    const [isSaveASNDatailEnable, setisSaveASNDatailEnable] = useState(false)

    let tokenData = parseJwt(sessionStorage.getItem("token")) || {};
    const uploadMasterDataImagesData = useSelector(state => state?.masterdbStore?.uploadMasterDataImagesData);

    const downloadReportData = useSelector(state => state?.generalStore?.downloadReportData);

    useEffect(() => {
        if (callErrroValidationFun) {
            finalSubmitValidationsCheck();
            setcallErrroValidationFun(false)
        }
    }, [callErrroValidationFun])

    const isClientHopscotch = () => {
        let hopscotchSchemaEntId = ["8534", "754"];
        return hopscotchSchemaEntId?.some(t => t == tokenData?.schemaEntID)
    }

    // Effect  : To handle the effect of the sku wise boxes data
    useEffect(() => {
        if (!isEdit && poDetailsResponse?.boxTemplateConfig) {
            if (state?.boxCreation) {
                setOpenedModal("createBoxTemplateModal");
            } else {
                if (state?.boxTemplate) {
                    setState(prev => {
                        prev["boxTemplate"] = null;
                        return prev;
                    })
                }
            }
        }
    }, [state.boxCreation])

    useEffect(() => {
        const anyHold = originalPoDetails?.some(item => item?.isPoItemHold || item?.tnaCompleted===false );
        setAnyPoOnHold(anyHold);
    }, [originalPoDetails]);

    // Check for the Stock Readiness option is out of stock if true then make the expectedDeliveryDate is today only
    useEffect(() => {
        if (isClientHopscotch?.()) {
            // formData?.["stockRediness"]?.["stockRediness"]?.toLowerCase()?.includes("out of stock") ||  old condition
            if (formData?.stockRediness?.stockRediness?.trim().includes("缺货，取消订单|| Out of stock, cancel order")) {
                let updatedFormData = { ...formData };
                updatedFormData["shipmentRequestDate"] = dayjs();
                setFormData(updatedFormData);

                let updatedErrorData = { ...errorData };
                delete updatedErrorData?.["shipmentRequestDate"];
                delete updatedErrorData?.["brandLabel"];
                delete updatedErrorData?.["stockRediness"];
                setErrorData(updatedErrorData);
            }
        }
    }, [formData?.["stockRediness"]])

    useEffect(() => {
        if(digiVendStore?.createASNUploadExcelData?.isSuccess) {
            setOpenedModal(false);
            let data = digiVendStore?.createASNUploadExcelData?.data?.resource || [];
            let checkKey = selectedData?.poType === "poicode" ? "orderDetailId" : "setHeaderId";
            const poDetailsData = poDetails.map(itemA => {
                const found = data?.find(itemB => itemB?.[checkKey] === itemA?.[checkKey]);
                return found ? {
                    ...itemA,
                    ...found,
                    totalAvaliableQty : found.availableQty + found.newRequestedQty,
                } : itemA;
            });

            let overallRequestedQty = 0, overallAvailableQty = 0, overallOrderPercentage = 0;
            poDetailsData?.forEach(item => {
                if (item.newRequestedQty > 0) {
                    overallAvailableQty += item.availableQty;
                    overallRequestedQty += +item.newRequestedQty;
                }
            });
            overallOrderPercentage = (overallRequestedQty / overallAvailableQty) * 100;

            for(let index = 0; index < poDetailsData?.length ; index ++ ){
                let rowPerValue = (Number(poDetailsData?.[index]?.newRequestedQty) / poDetailsData?.[index]?.availableQty) * 100;

                if (poDetailsData?.[index]?.newRequestedQty && poDetailsData?.[index]?.consumptionConfigValue && rowPerValue < Number(poDetailsData?.[index]?.consumptionConfigValue)) {
                    poDetailsData[index].minQtyError = `Request Qty must be at least ${poDetailsData?.[index]?.consumptionConfigValue}% of ${poDetailsData?.[index].availableQty}`;
                }
                else if (poDetailsData?.[index]?.consumptionConfigValue && poDetailsData[index].minQtyError) {
                    poDetailsData[index].minQtyError = "";
                }
            }

            let overallRequestedQtyError = "";
            if (vendConfig?.asnCreationFulfilmentRequired?.toLowerCase() === "true") { // Percentage criteria is applicable
                if (vendConfig?.cancelLinePendingQty?.toLowerCase() === "true") { // newRequestedQty can be 0 for some rows
                    if (overallOrderPercentage < Number(vendConfig?.asnCreationFulfilment)) {
                        overallRequestedQtyError = `Total Request Qty must be at least ${vendConfig?.asnCreationFulfilment}% of ${overallAvailableQty}`;
                    }
                    else overallRequestedQtyError = "";
                }
                // newRequestedQty cannot be 0 for any row        
                poDetailsData?.forEach(item => {
                    if (Number(item.availableQty) > 0 && Number(item?.newRequestedQty) > 0) {
                        let minRequiredPercentage = Math.max(
                            Number(item?.consumptionConfigValue || 0),
                            Number(vendConfig?.asnCreationFulfilment || 0)
                        );
                        const orderPercentage = (Number(item.newRequestedQty) / item.availableQty) * 100;
                        if (orderPercentage < minRequiredPercentage) {
                            item.minQtyError = `Request Qty must be at least ${minRequiredPercentage}% of ${item.availableQty}`;
                        }
                        else item.minQtyError = ""
                    }
                    else item.minQtyError = ""
                });
            }
            else {
                if (!overallRequestedQty) {
                    overallRequestedQtyError = "Total Request Qty cannot be 0";
                }
                else overallRequestedQtyError = "";
            }

            setPoDetails(poDetailsData)
            setOriginalPoDetails(poDetailsData)
            setState({
                ...state,
                overallRequestedQtyError: overallRequestedQtyError
            })
            setCallAutoInvoiceAmount({ funCall: true, poDetailsData: poDetailsData, funName: "checkAsnAmount" });
        }
    }, [digiVendStore?.createASNUploadExcelData?.isSuccess]);

    useEffect(() => {
        if (updateImageState) {
            setUpdateImageState(false);
        }
    }, [updateImageState])

    useEffect(() => {
        if (getDigicatFormSettingsData?.isSuccess) {
            setFormSettings(getDigicatFormSettingsData?.data?.resource || {})
            getAsnInfoForEdit()
        }
        if(getDigicatFormSettingsData?.isError){
            getAsnInfoForEdit()
        }
    }, [getDigicatFormSettingsData])

    // Get the local dropdown data 

    useEffect(() => {
        ["BRAND_LABEL", "STOCK_READINESS", "BARCODE_STATUS", "BARCODE_TYPE_ASN", "CARTON_SIZE", "OUT_OF_STOCK"]?.map(key => {
            handleApiChange(dispatch, "getDropdownRequest", {
                type: key
            })
        })
    }, [])

    // On the change of the shipment packing type 
    // Update the boxes data to no boxes
    useEffect(() => {
        if (currentShipmentTypeData != "calculating" && (currentShipmentTypeData?.["shipmentPackingType"] != formData?.["shipmentPackingType"]?.["shipmentPackingType"])) {
            setBackupShipmentTypeData(currentShipmentTypeData);
            setCurrentShipmentTypeData(formData?.["shipmentPackingType"]);
            if (boxes?.length > 0) {
                setOpenedModal("dicardAsnBoxesConfirmation");
            }
        }
    }, [formData?.["shipmentPackingType"]])

    useEffect(() => {
        if (generalStore?.getDocumentDownloadFilepathData?.isSuccess) {
            if (getImagesOf) {
                let formDataClone = { ...formData };
                formDataClone = {
                    ...formDataClone,
                    [getImagesOf]: generalStore?.getDocumentDownloadFilepathData?.data
                }
                setFormData(formDataClone);
                setGetImagesOf("");
                setUpdateImageState(!updateImageState);
            }
        }
    }, [generalStore?.getDocumentDownloadFilepathData?.isSuccess])

    useEffect(() => {
        if (generalStore?.["getDropdownData"]?.isSuccess) {
            let data = generalStore?.["getDropdownData"]?.data || {};
            setLocalDropdownData(prev => (data.type ? { ...prev, [data.type]: data?.resource || [] } : prev))
        }
    }, [generalStore?.["getDropdownData"]?.isSuccess])

    useEffect(() => {
        if (resetDataForDraftAsn) {
            let poDetailsData = [...poDetails], skuWiseBoxesData = {};
            poDetailsData.forEach(item => {
                if (isAllQtyZero) {
                    item.newRequestedQty = 0;
                    item.setPendingQty = item.availableQty;
                }
                else if (!state?.boxCreation) { // Request quantity is set to available quantity when box creation is turned off
                    item.newRequestedQty = (item?.isPoItemHold || item?.tnaCompleted === false) ? 0 : item.availableQty;
                    item.setPendingQty = (item?.isPoItemHold || item?.tnaCompleted === false) ? item.availableQty : 0;
                }
                else { // Request quantity is set to 0 when box creation is turned on
                    item.newRequestedQty = 0;
                    item.setPendingQty = item.availableQty;
                }
                item.newCancelledQty = 0;
                item.minQtyError = "";
                item.maxQtyError = "";

                skuWiseBoxesData[item.id] = [];
            });
            setPoDetails(poDetailsData);
            setOriginalPoDetails(poDetailsData)
            setSkuWiseBoxes(skuWiseBoxesData)

            setResetDataForDraftAsn(false);
            setCurrentDraftAsnIndex(-1)
            setCallAutoInvoiceAmount({ funCall: true, poDetailsData: poDetailsData, funName: "checkAsnAmount" });
        }
    }, [resetDataForDraftAsn])

    const getMaxDeliveryDate = (data) => {
        const validDates = data
            ?.map?.(item => dayjs?.(item?.deliveryDate))
            ?.filter?.(date => date?.isValid?.());

        if (!validDates?.length) return null;

        return validDates?.reduce((maxDate, currentDate) =>
            currentDate?.isAfter?.(maxDate) ? currentDate : maxDate
        );
    };

    const updateStateForCreateForm = (response, type = "normal", defaultFormValues = {}) => {
        console.log("type dsfdsfs", type)
        let poDetailsData = response?.poDetails
        // poDetailsData = poDetailsData?.map((item, index) => ({ 
        //     ...item, 
        //     consumptionConfigValue: index + 1 
        // }));

        let mixedBoxesAllowedInThisPo = false,
            id = selectedData?.poType === "poicode" ? "itemCode" : "setBarCode",
            boxesData = [], boxCreation = state.boxCreation, boxPrefix = "",
            skuWiseBoxesData = {},
            isBoxesAvailable = isEdit && response?.boxes?.[0]?.skus?.length;
        poDetailsData?.forEach(item => {
            item.id = item[id];
            item.totalAvaliableQty = item.availableQty + item.newRequestedQty;
            item.initialAvaliableQty = type === "fromAPI" ? item.availableQty + item.newRequestedQty : undefined;
            // item.initialCancelQty = type === "fromAPI" ? selectedData?.poType === "poicode" ? (item.orderQty - item.availableQty) : 0 : 0;
            // minQtyError: stores error applicable on the input quantity, if it is less than min request qty allowed.
            item.minQtyError = "";
            // maxQtyError: stores error applicable on the input quantity, if it is more than max request qty allowed.
            item.maxQtyError = "";

            if(isAllQtyZero){
                item.newRequestedQty = (item?.isPoItemHold || item?.tnaCompleted===false) ? 0 : isAllQtyZero ? 0 : item.newRequestedQty;
                item.setPendingQty = (item?.isPoItemHold || item?.tnaCompleted===false) ? item.availableQty :  isAllQtyZero ? item.availableQty : item?.setPendingQty;
            }

            skuWiseBoxesData[item.id] = isBoxesAvailable ? (isEdit ? response?.boxes : []).map(item => null) : [null];
        });

        setPoDetails(poDetailsData);
        setOriginalPoDetails(poDetailsData)
        boxPrefix = isEdit ? response.boxPrefix : response.boxPrefix;
        let poData = { ...selectedData };
        mixedBoxesAllowedInThisPo = response?.mixedSku == 1 ? true : false
        if(!mixedBoxesAllowedInThisPo && vendConfig?.ENABLE_BOX_GENERATION?.toLowerCase() === "mandatory"){
            setIsAllQtyZero(true);
        }
        poData = {
            ...poData,
            asnNo: vendConfig?.asnMask?.toLowerCase() === "true" ? response?.asnMask : response?.shipmentAdviceCodeDraft || response?.shipmentAdviceCode,
            asnFromSelectionDate: response?.asnFromSelectionDate,
            shipmentAdviceCode: response?.shipmentAdviceCode,
            asnToSelectionDate: response?.asnToSelectionDate,
            validFromSelectionDate: response?.validFromSelectionDate,
            validToSelectionDate: response?.validToSelectionDate,
            orderCode: isEdit ? response?.orderCode || selectedData?.orderCode : selectedData?.orderCode,
            lateDeliveryCharges: response?.lateDeliveryCharges || 0,
        };
        if(!isEdit) {
            poData.asnMask = response?.asnMask;
        }
        setSelectedData(poData);

        if (isEdit) {
            let formDataClone = JSON.parse(JSON.stringify(formData)), uploadedFileDirectoryData = { ...uploadedFileDirectory };
            formDataClone = {
                ...formDataClone,
                shipmentRequestDate: response?.shipmentRequestDate ? dayjs(response?.shipmentRequestDate, getCurrentDateFormat(response?.shipmentRequestDate)) : "",
                qcFromDate: response?.qcFromDate ? dayjs(response?.qcFromDate, getCurrentDateFormat(response?.qcFromDate)) : "",
                qcToDate: response?.qcToDate ? dayjs(response?.qcToDate, getCurrentDateFormat(response?.qcToDate)) : "",
                contactPerson: response?.contactPerson || "",
                contactNo: response?.contactNo || "",
                address: { address: response?.address || "" },
                location: { location: response?.location || "" },
                transporter: { transporterName: response?.transporterName || "", transporterCode: response?.transporterCode || "" },
                invoiceNumber: response?.invoiceNumber || "",
                invoiceAmount: response?.invoiceAmount || "",
                invoiceQuantity: response?.poQty || "",
                unitCount: response?.unitCount || "",
                invoiceDate: response?.invoiceDate ? dayjs(response?.invoiceDate, getCurrentDateFormat(response?.invoiceDate)) : "",
                stockRediness: response?.stockRediness ? { "stockRediness": response?.stockRediness?.substring(0, response?.stockRediness?.lastIndexOf('||')), "value": response?.stockRediness?.substring(response?.stockRediness?.lastIndexOf('||') + 2) } : null,
                brandLabel: getInputType("brandLabel") == "text" ? response?.brandLabel :  response?.brandLabel ? !isClientHopscotch?.() ? {brandLabel: response?.brandLabel, value: response?.brandLabel } : { "brandLabel": response?.brandLabel?.substring(0, response?.brandLabel?.lastIndexOf('||')), "value": response?.brandLabel?.substring(response?.brandLabel?.lastIndexOf('||') + 2) } : null,
                barcodeStatus: response?.barcodeStatus ? { barcodeStatus: response?.barcodeStatus } : null,
                barcodeType: getInputType("barcodeType") == "text" ?  response?.barcodeType : response?.barcodeType ? { barcodeType: response?.barcodeType || "" } : null,
                cartonSize: response?.cartonSize ? { cartonSize: response?.cartonSize || "" } : null,
                remarks: response?.remarks || "",
                shipmentPackingType: response?.shipmentPackingType ? { "shipmentPackingType": response?.shipmentPackingType } : null,
                awbNumber: response?.awbNumber || ""
            };
            let obj = {
                ppsDoc: "folderDirectoryPPS",
                testReport: "folderDirectoryReport",
                packingList: "folderDirectoryPackaging",
                invoiceUpload: "folderInvoice",
            }
            Object.keys(obj).forEach(key => {
                if (response?.[obj?.[key]]) {
                    uploadedFileDirectoryData[key] = response?.[obj?.[key]]
                }
            })
            type = "normal" && setUploadedFileDirectory(uploadedFileDirectoryData);
            type = "normal" && setFormData(formDataClone);
            type = "normal" && setInitialSkuWiseBoxesData({
                skuWiseBoxes: skuWiseBoxesData,
                boxesData: boxesData,
            });
        }
        else {
            const isStyleBazaar = tokenData?.schemaEntID?.toString?.() === "385", isLouisStitch = ["20513", "1"].includes(tokenData?.schemaEntID?.toString());
            const inspectionDiff = Number(vendConfig?.inspectionFromToDifference) || 0;
            let styleBazaarDefaults = {};
            if (isStyleBazaar) {
                // Build candidate auto-populate dates and validate each against disabledDateFun
                // before applying. selectedData is not updated yet here (setSelectedData is async),
                // so the freshly built poData is passed explicitly.
                // - shipmentRequestDate: taken from the PO validity end; left blank if not selectable
                //   (e.g. validity already expired) so the user picks a valid date manually.
                // - qcFromDate: starts at today and rolls forward to the first selectable date.
                // - qcToDate: kept inspectionDiff days after the resolved qcFromDate.
                const findNextAvailableDate = (startDate, field, formDataArg, maxDays = 56) => {
                    let candidate = startDate;
                    for (let i = 0; i < maxDays; i++) {
                        if (!disabledDateFun(candidate, field, poData, formDataArg)) return candidate;
                        candidate = candidate.add(1, "day");
                    }
                    return "";
                };
                const shipmentCandidate = response?.validToDate ? dayjs(response?.validToDate, getCurrentDateFormat(response?.validToDate)) : "";
                const resolvedShipment = shipmentCandidate && !disabledDateFun(shipmentCandidate, "shipmentRequestDate", poData) ? shipmentCandidate : "";
                // qcFromDate's upper bound is the shipment date, so validate against the freshly
                // resolved shipment instead of the stale formData value (dayjs(undefined) === today,
                // which would otherwise disable every future date and clear the field).
                const overrideFormData = { ...formData, shipmentRequestDate: resolvedShipment };
                const qcFromResolved = resolvedShipment ? findNextAvailableDate(dayjs(), "qcFromDate", overrideFormData) : "";
                const qcDummyDate = qcFromResolved ? dayjs(qcFromResolved.add(inspectionDiff, "days"), getCurrentDateFormat(qcFromResolved.add(inspectionDiff, "days"))) : "";
                const qcToResolved = qcDummyDate ? !(disabledDateFun(qcDummyDate, "qcToDate", poData, {...overrideFormData, qcFromDate: qcFromResolved })) ? qcDummyDate : "" : "";
                styleBazaarDefaults = {
                    shipmentRequestDate: resolvedShipment,
                    qcFromDate: qcFromResolved,
                    qcToDate: qcToResolved,
                };
            }
            if(isLouisStitch) {
                const maxDate = getMaxDeliveryDate(response?.poDetails);
                styleBazaarDefaults = {
                    shipmentRequestDate: maxDate ? dayjs(maxDate) : ""
                }

            }
            type = "normal" && setFormData(isEdit ? {
                ...formData,
                qcFromDate: response?.qcFromDateSelection || "",
                qcToDate: response?.qcToDateSelection || "",
            } : {
                ...defaultFormValues,
                qcFromDate: response?.qcFromDateSelection || "",
                qcToDate: response?.qcToDateSelection || "",
                ...styleBazaarDefaults,
            });
        }


        if (isBoxesAvailable) {
            response?.boxes.forEach((item, index) => {
                boxesData.push({
                    id: item?.box_id || index + 1,
                    boxCount: item.box_count,
                    prev_box_count: item.box_count,
                    boxWeight: item.box_weight,
                    viewSKU: false,
                    shipmentBoxId: item.shipmentBoxId,
                    boxNumber: item.boxNumber,
                    boxTemplate: isEdit && item?.box_id ? { box_id: item?.box_id } : null,
                    boxTemplateId: item?.boxTemplateId
                });
                item?.skus?.forEach(innerItem => {
                    if (!skuWiseBoxesData?.[innerItem.sku]) {
                        skuWiseBoxesData[innerItem.sku] = []
                    }
                    skuWiseBoxesData[innerItem.sku][index] = Number(innerItem.qty) || null;
                });
            });
            boxCreation = true;
            type = "normal" && handleTabChange("createBox", false)
            // setCurrentTab("createBox");
        };
        setEditResponse(response);
        let callConfirmatioFunClone = false;
        if (vendConfig?.ENABLE_BOX_GENERATION?.toLowerCase() === "mandatory") {
            callConfirmatioFunClone = true
        }
        setState({
            ...state,
            boxCreation: boxCreation,
            mixedBoxesAllowedInThisPo: mixedBoxesAllowedInThisPo,
            boxPrefix: boxPrefix,
            emptyCartonWeight: response?.emptyCartonWeight ?? "",
            // boxTemplate: isEdit && response?.boxTemplateId ? { id: response?.boxTemplateId } : null
        });
        setCallConfirmatioFun(callConfirmatioFunClone)
        setSkuWiseBoxes(skuWiseBoxesData);
        setBoxes(boxesData);

        if (vendConfig?.VALIDATE_INV_AND_ASN_AMT.toLowerCase() === "auto" && callAutoInvoiceAmount?.funCall) {
            setCallAutoInvoiceAmount({ funCall: true, poDetailsData: poDetailsData, funName: "checkAsnAmount" });
        }

    }

    const finalSubmitValidationsCheck = () => {
        let updatedErrorData = {};
        let inputFields = getInputs();

        inputFields?.map(item => {
            updatedErrorData[item?.key] = [];
            // Mandatory condition check
            if (item?.mandatory && !formData?.[item?.key]) {
                if (item?.type === "upload" && isEdit) {
                    if (!uploadedFileDirectory?.[item?.key]) {
                        updatedErrorData?.[item?.key].push(`${item?.label} is a mandatory field, please upload the file.`)
                    }
                    else delete updatedErrorData?.[item?.key];
                }
                else updatedErrorData?.[item?.key].push(`${item?.label} is a mandatory field, please provide a valid value inside input.`)
            } else if (item?.type === "number") {
                let errorMessages = validateNumber(formData?.[item?.key] || "", "number", "number")
                errorMessages?.length > 0 && updatedErrorData?.[item?.key].push(errorMessages);
            }
            else if (item?.type === "mobileNo" && formData?.[item?.key]  && formData?.[item?.key] !== "+91") {
                let isMobileNumberValid = validateMobileNumber(formData?.[item?.key])
                !isMobileNumberValid && updatedErrorData?.[item?.key].push(`Please provide a valid mobile number inside ${item?.label} input field.`);
            }

            if (updatedErrorData?.[item?.key]?.length === 0) {
                delete updatedErrorData?.[item?.key];
            }
        })
        setErrorData({ ...updatedErrorData });
        return Object.keys(updatedErrorData || {})?.length > 0 ? false : true
    }

    useEffect(() => {
        dispatchHandler(dispatch, "getDigicatFormSettingsRequest", { type: vendConfig?.["inspectionRequired"]?.toLowerCase() === "true" ? "inspection" : "asn", formSubType: "" }, getPermissionKey("purchase", "shipment", isEdit ? "update" : "create"));
    }, [])

    useEffect(() => {
        if (state?.boxCreation) {
            setCheckEligibleASN(false);
        }
    }, [state?.boxCreation]);


    const getAsnInfoForEdit = () => {
        let payload = {
            detailType: selectedData?.poType == "poicode" ? "item" : "set",
            orderId: selectedData?.id,
            poType: selectedData?.poType,
            setHeaderId: "",
            version: "v2",
            dataType: "create"
        }
        setUuId(uuidv4() + (tokenData.jti || ""));
        if (isEdit) {
            let formDataClone = JSON.parse(JSON.stringify(formData));
            formDataClone = {
                ...formDataClone,
                shipmentRequestDate: selectedData?.shipmentRequestSelectionDate ? dayjs(selectedData?.shipmentRequestSelectionDate, getCurrentDateFormat(selectedData?.shipmentRequestSelectionDate)) : "",
                qcFromDate: selectedData?.qcFromDateSelection ? dayjs(selectedData?.qcFromDateSelection, getCurrentDateFormat(selectedData?.qcFromDateSelection)) : "",
                qcToDate: selectedData?.qcToDateSelection ? dayjs(selectedData?.qcToDateSelection, getCurrentDateFormat(selectedData?.qcToDateSelection)) : "",
                contactPerson: selectedData?.contactPerson || "",
                contactNo: selectedData?.contactNo || "",
                address: { address: selectedData?.address || "" },
                location: { location: selectedData?.location || "", email: selectedData?.locationEmail },
                stockRediness: selectedData?.stockRediness ? { "stockRediness": selectedData?.stockRediness?.substring(0, selectedData?.stockRediness?.lastIndexOf('||')), "value": selectedData?.stockRediness?.substring(selectedData?.stockRediness?.lastIndexOf('||') + 2) } : null,
                brandLabel:  getInputType("brandLabel") == "text" ? selectedData?.brandLabel :  selectedData?.brandLabel ? !isClientHopscotch?.() ? {brandLabel: selectedData?.brandLabel, value: selectedData?.brandLabel } : { "brandLabel": selectedData?.brandLabel?.substring(0, selectedData?.brandLabel?.lastIndexOf('||')), "value": selectedData?.brandLabel?.substring(selectedData?.brandLabel?.lastIndexOf('||') + 2) } : null,
                shipmentPackingType: selectedData?.shipmentPackingType ? { "shipmentPackingType": selectedData?.shipmentPackingType } : null,
                barcodeStatus: selectedData?.barcodeStatus ? { barcodeStatus: selectedData?.barcodeStatus } : null,
                barcodeType: getInputType("barcodeType") == "text" ?  selectedData?.barcodeType : selectedData?.barcodeType ? { barcodeType: selectedData?.barcodeType || "" } : null,
                cartonSize: selectedData?.cartonSize ? { cartonSize: selectedData?.cartonSize || "" } : null,
                remarks: selectedData?.remarks || "",
                awbNumber: selectedData?.awbNumber || "",
            };
            setFormData(formDataClone);

            payload.orderId = selectedData?.orderId
            payload.shipmentStatus = selectedData?.poStatus
            payload.shipmentId = selectedData?.shipmentId
            payload.updateAsn = true
            payload = {
                shipmentId: selectedData?.shipmentId
            };
            dispatchHandler(dispatch, "purchaseShipmentAutoDetailRequest", payload, getPermissionKey("purchase", "shipment", isEdit ? "update" : "create"))
        }
        else {
            dispatchHandler(dispatch, "vendorpoGetPodetailRequest", payload, getPermissionKey("purchase", "shipment", isEdit ? "update" : "create"))
        }
        getTableHeaders("db");
    }

    useEffect(() => {
        if (expandedSetRow) {
            let payload = {
                detailType: "item",
                orderId: selectedData?.id,
                poType: selectedData?.poType,
                setHeaderId: expandedSetRow?.setHeaderId,
                dataType: 'view',
                version: ""
            }
            if (isEdit) {
                payload = {
                    shipmentId: selectedData?.shipmentId,
                    setHeaderId: expandedSetRow?.setHeaderId
                }
                dispatchHandler(dispatch, "vendorshipFindSrdetailRequest", payload, getPermissionKey("purchase", "shipment", isEdit ? "update" : "create"))
            }
            else {
                dispatchHandler(dispatch, "vendorpoGetPodetailRequest", payload, getPermissionKey("purchase", "shipment", isEdit ? "update" : "create"))
            }
        }
    }, [expandedSetRow])

    const getTableHeaders = from => {
        switch (from) {
            case "db": {
                Object.keys(headerKey).forEach(key => {
                    handleApiChange(dispatch, "getHeadersRequest", {
                        enterpriseName: "TURNINGCLOUD",
                        displayName: headerKey[key].key,
                        basedOn: key
                    })
                });
                break;
            }
        }

    }

    useEffect(() => {
        const res = isEdit ? !expandedSetRow ? digiVendStore?.purchaseShipmentAutoDetailData : digiVendStore?.vendorshipFindSrdetailData : digiVendStore?.vendorpoGetPodetailData;
        if (res?.isSuccess) {
            if (!expandedSetRow) {

                let response = isEdit ? res.data : res?.data?.resource;

                updateStateForCreateForm(response, "fromAPI");
                if (isEdit && currentShipmentTypeData == "calculating") {
                    // Sync to the loaded packing type (not null) so the watcher useEffect's guard
                    // matches formData and won't open the discard-boxes modal on subsequent
                    // programmatic formData updates (e.g. editing a drafted ASN).
                    setCurrentShipmentTypeData(response?.shipmentPackingType ? { "shipmentPackingType": response?.shipmentPackingType } : null);
                }

                setPoDetailsResponse(response);
                setAsnSummary(response?.poASNSummary)   
            }
            else {
                setItemRowData(isEdit ? res?.data?.poDetails ? res?.data?.poDetails?.map(item => ({ ...item, id: item.itemCode })) : [] : res?.data?.resource?.poDetails ? res?.data?.resource?.poDetails?.map(item => ({ ...item, id: item.itemCode })) : [])
            }
        }

        if (generalStore?.getHeadersData?.isSuccess) {
            setHeadersType(prev => ({
                ...prev,
                [generalStore?.getHeadersData.data.basedOn]: generalStore?.getHeadersData?.data?.resource?.["Custom Headers"] === undefined || Object.keys(generalStore?.getHeadersData.data.resource["Custom Headers"]).length === 0 ? "Default Headers" : "Custom Headers",
            }));
            setHeadersData(prev => ({
                ...prev,
                [generalStore.getHeadersData.data.basedOn]: generalStore?.getHeadersData?.data?.resource
            }))
        }

        if (digiVendStore?.vendorshipCreateSrNewData?.isSuccess || digiVendStore?.createMultipleAsnData?.isSuccess) {
            closeModalV2();
        }

    }, [digiVendStore?.vendorpoGetPodetailData?.isSuccess, generalStore?.getHeadersData?.isSuccess, digiVendStore?.vendorshipFindSrdetailData?.isSuccess, digiVendStore?.vendorshipCreateSrNewData?.isSuccess, digiVendStore?.createMultipleAsnData?.isSuccess, digiVendStore?.purchaseShipmentAutoDetailData?.isSuccess]);

    useEffect(() => {
        if (!isEdit && callConfirmatioFun && vendConfig?.ENABLE_BOX_GENERATION?.toLowerCase() === "mandatory") {
            onConfirmation();
        }
    }, [callConfirmatioFun]);

    useEffect(() => {
        if (callAutoInvoiceAmount?.funCall && callAutoInvoiceAmount?.funName === "checkAsnAmount") {
            checkAsnAmount(callAutoInvoiceAmount.poDetailsData)
            setCallAutoInvoiceAmount({ funCall: false });
        }
    }, [callAutoInvoiceAmount])

    const disabledDateFun = (date, field, poDataOverride = selectedData, formDataOverride = formData) => {
        const poData = poDataOverride;
        let disabledDate = false;
        switch (field) {
            case "shipmentRequestDate": {
                if (vendConfig?.asnFromToApplicablility?.toLowerCase() === "true") {
                    disabledDate = disabledDate || dayjs(date).isBefore(dayjs(poData.asnFromSelectionDate), "days") || dayjs(date).isBefore(dayjs(), "days") || dayjs(date).isAfter(dayjs(poData.asnToSelectionDate), "days");
                    if (poData?.isCreateASNAllowed == 1) {
                        disabledDate = disabledDate || dayjs(date).isBefore(dayjs(poData.validFromSelectionDate), "days") || dayjs(date).isBefore(dayjs(), "days") || dayjs(date).isAfter(dayjs(poData.validToSelectionDate), "days");
                    }
                }
                else {
                    disabledDate = disabledDate || dayjs(date).isBefore(dayjs(poData.validFromSelectionDate), "days") || dayjs(date).isBefore(dayjs(), "days") || dayjs(date).isAfter(dayjs(poData.validToSelectionDate), "days");
                }
                break;
            }
            case "qcFromDate": {
                if (vendConfig?.asnFromToApplicablility?.toLowerCase() === "true" && poData?.isCreateASNAllowed == 1) {
                    disabledDate = disabledDate || dayjs(date).isBefore(dayjs(poData?.asnFromSelectionDate), "days") || dayjs(date).isBefore(dayjs().add(1, "day"), "days") || dayjs(date).isAfter(dayjs(formDataOverride?.shipmentRequestDate), "days");
                }
                else if (Number(vendConfig?.inspectionFromToDifference) == 0 || vendConfig?.inspectionFromToDifference == "" || vendConfig?.inspectionFromToDifference == null) {
                    disabledDate = disabledDate || dayjs(date).isBefore(dayjs(poData?.validFromSelectionDate), "days") || dayjs(date).isBefore(dayjs().add(0, "day"), "days") || dayjs(date).isAfter(dayjs(formDataOverride?.shipmentRequestDate), "days");
                }
                else {
                    disabledDate = disabledDate || dayjs(date).isBefore(dayjs(poData.validFromSelectionDate), "days") || dayjs(date).isBefore(dayjs().add(1, "day"), "days") || dayjs(date).isAfter(dayjs(formDataOverride?.shipmentRequestDate), "days");
                }
                break;
            }
            case "qcToDate": {
                disabledDate = disabledDate || dayjs(date)?.isBefore(dayjs(formDataOverride?.qcFromDate).add(vendConfig?.inspectionFromToDifference, "days"), "days") || dayjs(date).isAfter(dayjs(formDataOverride?.shipmentRequestDate), "days");
                break;
            }
            case "invoiceDate": {
                disabledDate = disabledDate || date > dayjs().endOf('day')
                break;
            }
        }

        return disabledDate;
    }

    // Function : To render the custom label of the input fields
    const renderCustomLabel = (config) => {
        let { key } = config;
        switch (key) {
            case "address": {
                return (
                    <>
                        <GenericCustomButton
                            className="manage-address-btn"
                            leftIcon={<Icons.EditIcon />}
                            onClick={() => handleChange("manageAddress")}
                        />
                    </>
                )
            }
        }
    }

    const callApiToGetImages = (key) => {
        let fileDir = uploadedFileDirectory?.[key];
        setGetImagesOf(key)
        let permissionsObj = getPermissionKey("purchase", "shipment", isEdit ? "update" : "create")
        if (fileDir && !formData?.[key]?.length) {
            let payload = {
                disposition: "FALSE",
                fileDirectory: fileDir,
            }
            dispatchHandler(dispatch, "getDocumentDownloadFilepathRequest", payload, permissionsObj);
        }
    }

    const clearUploadFiles = (key) => {
        let formDataClone = JSON.parse(JSON.stringify(formData)), fileDirectory = { ...uploadedFileDirectory };
        if (formDataClone?.[key]) {
            delete formDataClone?.[key];
            setFormData(formDataClone);
        }
        delete fileDirectory?.[key];
        setUploadedFileDirectory(fileDirectory);
    }

    // Function : to get the input type
    const getInputType = (key) => {
        let mapping = {
            "LOV" : "dropdown",
            "TEXT" : "text"
        }
        return mapping?.[formSettings?.[key]?.["inputType"]] || ""
    }

    // Function : Credit note upload is mandatory while creating an ASN when the late delivery charge strip is visible and ENABLE_CR_UPLOAD_ON_LDP_ASN is TRUE
    const isCreditNoteUploadRequired = () => {
        return !isEdit && Number(selectedData?.lateDeliveryCharges ?? 0) > 0 && vendConfig?.ENABLE_CR_UPLOAD_ON_LDP_ASN?.toString?.()?.toUpperCase?.() === "TRUE";
    }

    const getInputs = () => {
        // 0 -> key
        // 1 -> label
        // 2 -> value
        // 3 -> type
        // 4 -> isDisabled
        // 5 -> mandatory
        // 6 -> onChange
        // 7 -> inputProps
        // 8 -> iconRight
        // 9 -> clearFun
        // 10-> dateDisabled
        // 11=> customInputValue
        // 12=> onBlur
        let obj = {};

        obj = {
            "shipmentRequestDate": ["Expected Delivery", formData?.shipmentRequestDate ? dayjs(formData?.shipmentRequestDate, getCurrentDateFormat(formData?.shipmentRequestDate)) : "", "date", (isEdit || false), true, (state, data) => handleClearDate("shipmentRequestDate", {state, data}), null, null, () => handleClear("shipmentRequestDate"), (date) => disabledDateFun(date, 'shipmentRequestDate')],
            "qcFromDate": ["Inspection From", formData?.qcFromDate ? dayjs(formData?.qcFromDate, getCurrentDateFormat(formData?.qcFromDate)) : "", "date", (!formData?.shipmentRequestDate || isEdit), true, (state, data) => handleClearDate("qcFromDate", {state, data}), null, null, () => handleClear("qcFromDate"), (date) => disabledDateFun(date, 'qcFromDate')],
            "qcToDate": ["Inspection To", formData?.qcToDate ? dayjs(formData?.qcToDate, getCurrentDateFormat(formData?.qcToDate)) : "", "date", (!formData?.qcFromDate || isEdit), true, null, null, null, null, (date) => disabledDateFun(date, 'qcToDate')],
            "contactPerson": ["Contact Person", formData?.contactPerson || "", "text", (isEdit || false), true],
            "contactNo": ["Contact Number", formData?.contactNo || "", "mobileNo", (isEdit || false), true],
            "address": ["Address", formData?.address || "", "dropdown", (isEdit || false), (vendConfig?.mandateAddressSelection?.toLowerCase() === "true" ? true : false), null, () => getInputProps("address"), <Icons.GlobalSearchIcon />],
            "location": ["Location", formData?.location || "", "dropdown", (isEdit || false), true, null, () => getInputProps("location"), <Icons.GlobalSearchIcon />],
            "ppsDoc": ["Upload PPS Document", formData?.ppsDoc || "", "upload", (isEdit || false), false, null, () => getInputProps('ppsDoc'), false, false, false, (value) => `${(formData?.ppsDoc?.length == 0 || !formData?.ppsDoc) ? "" : `${formData?.ppsDoc?.length} ${formData?.ppsDoc?.length <= 1 || !formData?.ppsDoc ? "File" : "Files"}`}`],
            "testReport": ["Upload Test Report", formData?.testReport || "", "upload", (isEdit || false), false, null, () => getInputProps('testReport'), false, false, false, () => `${(formData?.testReport?.length == 0 || !formData?.testReport) ? "" : `${formData?.testReport?.length} ${formData?.testReport?.length <= 1 || !formData?.testReport ? "File" : "Files"}`}`],
            "packingList": ["Upload Packing List", formData?.packingList || "", "upload", (isEdit || false), false, null, () => getInputProps('packingList'), false, false, false, () => `${(formData?.packingList?.length == 0 || !formData?.packingList) ? "" : `${formData?.packingList?.length} ${formData?.packingList?.length <= 1 || !formData?.packingList ? "File" : "Files"}`}`],
            "transporter": ["Transporter field", formData?.transporter || "", "dropdown", (isEdit || false), (vendConfig?.TRANSPORTER_AT_CREATE_ASN?.toLowerCase() === "mandatory" || false), null, () => getInputProps("transporter"), <Icons.GlobalSearchIcon />, null, null, (val) => { return val ? val?.transporterName : "" }],
            "invoiceNumber": ["Invoice Number", formData?.invoiceNumber || "", "text", (isEdit || false), true],
            "invoiceAmount": ["Invoice Amount", formData?.invoiceAmount || "", "decimal", (vendConfig?.VALIDATE_INV_AND_ASN_AMT?.toLowerCase() === "auto" || false), true, null, null, null, null, null, null, (val) => handleBlur(val, "invoiceAmount")],
            "invoiceQuantity": ["Invoice Quantity", formData?.invoiceQuantity || "", "decimal", (vendConfig?.VALIDATE_INV_AND_ASN_AMT?.toLowerCase() === "auto" || false), true, null, null, null, null, null, null, (val) => handleBlur(val, "invoiceQuantity")],
            "unitCount": ["Number of Cartons", formData?.unitCount || "", "number", ((isEdit || state?.boxCreation) || false), true],
            "invoiceUpload": ["Invoice Upload", formData?.invoiceUpload || "", "upload", (isEdit || false), ((vendConfig?.invoiceUploadRequired?.toLowerCase() === "true") || false), null, () => getInputProps('invoiceUpload'), false, false, false, (value) => `${(formData?.invoiceUpload?.length == 0 || !formData?.invoiceUpload) ? "" : `${formData?.invoiceUpload?.length} ${formData?.invoiceUpload?.length <= 1 || !formData?.invoiceUpload ? "File" : "Files"}`}`],
            "invoiceDate": ["Invoice Date", formData?.invoiceDate ? dayjs(formData?.invoiceDate, getCurrentDateFormat(formData?.invoiceDate)) : "", "date", (isEdit || false), true, null, null, null, null, (date) => disabledDateFun(date, 'invoiceDate')],
            "stockRediness": ["Stock Readiness", formData?.stockRediness || null, "dropdown", false, true, null, () => getInputProps("stockRediness"), <Icons.DownArrowNew />],
            "brandLabel": ["Brand Label", formData?.brandLabel || null, "dropdown", false, true, null, () => getInputProps("brandLabel"), <Icons.DownArrowNew />],
            "barcodeStatus": ["Barcode Status", formData?.barcodeStatus || null, "dropdown", false, true, null, () => getInputProps("barcodeStatus"), <Icons.DownArrowNew />],
            "barcodeType": ["Barcode Type", formData?.barcodeType || null, "dropdown", false, true, null, () => getInputProps("barcodeType"), <Icons.DownArrowNew />],
            "cartonSize": ["Carton Size", formData?.carton || null, "dropdown", false, true, null, () => getInputProps("cartonSize"), <Icons.DownArrowNew />],
            "awbNumber": ["AWB Number", formData?.awbNumber || "", "text", false, false],
            "remarks": ["Remarks", formData?.remarks || "", "text", false, false],
            "shipmentPackingType": ["Shipment Packing Type", formData?.shipmentPackingType || "", "dropdown", false, true, null, () => getInputProps("shipmentPackingType"), <Icons.DownArrowNew />],
        }

        let newObj = {
            shipmentRequestDate: "shipmentRequestDate",
            qcFromDate: "qcFromDate",
            qcToDate: "qcToDate",
            contactPerson: "contactPerson",
            contactNo: "contactNo",
            address: "address",
            location: "location",
            ppsDoc: "folderDirectoryPPS",
            testReport: "folderDirectoryReport",
            packingList: "folderDirectoryPackaging",
            transporter: "transporter",
            invoiceNumber: "invoiceNumber",
            invoiceAmount: "invoiceAmount",
            invoiceQuantity: "shipmentTotalRequestedQty",
            unitCount: "unitCount",
            invoiceUpload: "folderInvoice",
            invoiceDate: "invoiceDate",
            brandLabel: "brandLabel",
            stockRediness: "stockRediness",
            barcodeStatus: "barcodeStatus",
            barcodeType: "barcodeType",
            cartonSize: "cartonSize",
            remarks: "remarks",
            awbNumber: "awbNumber",
            shipmentPackingType: "shipmentPackingType",
        }

        let disableCheck = isEdit ? "isDisplayOnEditVendor" : "isEditableVendor"
        let disableAsnFieldCheck = {
            invoiceAmount: vendConfig?.VALIDATE_INV_AND_ASN_AMT?.toLowerCase() === "auto" || false,
            invoiceQuantity: vendConfig?.VALIDATE_INV_AND_ASN_AMT?.toLowerCase() === "auto" || false,
            unitCount: state?.boxCreation || false,
            qcFromDate: !formData?.shipmentRequestDate || false,
            qcToDate: !formData?.qcFromDate || false
        }
        Object.keys(obj || {})?.map((key) => {
            if (newObj?.[key] in formSettings) {
                if (formSettings?.[newObj?.[key]]?.["isDisplayVendor"] === 0) {
                    delete obj[key]
                }
                else {
                    obj[key][0] = formSettings?.[newObj?.[key]]?.["displayName"] || obj[key][0]
                    obj[key][3] = disableAsnFieldCheck?.[key] ? disableAsnFieldCheck?.[key] : formSettings?.[newObj?.[key]]?.[disableCheck] == 1 ? false : true
                    obj[key][4] = isEdit ? formSettings?.[newObj?.[key]]?.["isMandatoryOnEditVendor"] == 1 ? true : false : formSettings?.[newObj?.[key]]?.["isMandatoryVendor"] == 1 ? true : false
                }
            }
            else {
                delete obj[key]
            }

            let iconsMapping = {
                "dropdown" : <Icons.DownArrowNew />,
            }

            switch(key){
                case "barcodeType":
                case "brandLabel" : {
                    if(getInputType(key) && obj[key]){   
                        obj[key][2] = getInputType(key);
                        obj[key][7] = iconsMapping?.[ getInputType(key)]
                    }
                    break;
                }
            }
        });

        // Credit note upload is not driven by form settings: show it (mandatory) only when the late delivery charge strip is visible
        if (isCreditNoteUploadRequired()) {
            obj["creditNote"] = ["Upload Credit Note", formData?.creditNote || "", "upload", false, true, null, () => getInputProps('creditNote'), false, false, false, () => `${(formData?.creditNote?.length == 0 || !formData?.creditNote) ? "" : "1 File"}`];
        }

        const checkMandatoryCondition = (input, key) => {
            switch (key) {
                case "brandLabel": {
                    if (isClientHopscotch?.()) {
                        return formData?.stockRediness?.stockRediness?.trim().includes("缺货，取消订单|| Out of stock, cancel order") ? false : input?.[4] || false;
                    } else {
                        return input?.[4] || false;
                    }
                    break;
                }
                default: {
                    return input?.[4] || false;
                }
            }
        }

        return Object.keys(obj)?.map(key => {
            let input = obj?.[key];
            let temp = {
                key,
                label: input?.[0] || "",
                value: input?.[1] || "",
                type: input?.[2] || "text",
                isDisabled: input?.[3] || false,
                mandatory: checkMandatoryCondition(input, key),
                onChange: input?.[5] || false,
                iconRight: input?.[7] || false,
            }
            if (input?.[6]) {
                temp.inputProps = input?.[6]
            }
            if (input?.[8]) {
                temp.clearPressFunction = input?.[8]
            }
            if (input?.[9]) {
                temp.disabledDate = input?.[9]
            }
            if (input?.[10]) {
                temp.customInputValue = input?.[10]
            }
            if (input?.[11]) {
                temp.onBlur = input?.[11]
            }
            if (key == "ppsDoc" || key == "testReport" || key == "packingList" || key == "invoiceUpload" || key == "creditNote") {
                temp.callApiToGetImages = () => callApiToGetImages(key)
                if (uploadedFileDirectory?.[key] && !formData?.[key]?.length) {
                    temp["clearPressFunction"] = (data) => clearUploadFiles(key)
                    temp.customInputValue = () => "Edit Files"
                }
            }
            if (key == "address") {
                //  In case of address add the label right component
                console.log('input21323', input)
                temp.genInputExtraClass = input[1]?.address?.length > 127 ? 'address-dropdown-input' : null;
                temp.labelRightComponent = () => renderCustomLabel({ key: "address" });
            }
            if (key == "stockRediness" || key == "brandLabel") {
                temp.tooltip = true;
            }
            if (key == "contactNo") {
                //  In case of address add the label right component
                temp.showTooltipLenght = 5;
            }
            return temp;
        })
    }

    const handleBlur = (e, key) => {
        switch (key) {
            case "invoiceQuantity": {
                handleCheckInvoiceQty(e, 'blur', true)
            }
                break;
            case "invoiceAmount": {
                handlecheckAmount(e, 'blur', true)
            }
                break;
        }
    }

    const handlecheckAmount = (e, blur, showMessage) => {
        let value = e?.target?.value
        if ((e.key == "Enter" || blur == "blur")) {
            // if (vendConfig?.VALIDATE_INV_AND_ASN_AMT === "Restrict") {
            //     this.setState(prevState => ({
            //         inputErrors: {
            //             ...prevState.inputErrors,
            //             validateAmount: (vendConfig?.INV_AMT_TOLERANCE_TYPE !== "Disable" && vendConfig?.INV_AMT_TOLERANCE_AT_CREATE_ASN > 0) ? checkInvoiceAmountRange() : +value === +checkAsnAmount(poDetails) ? false : true,
            //         },
            //     }));
            // } 
            if (vendConfig?.VALIDATE_INV_AND_ASN_AMT === "Warn" && ((vendConfig?.INV_AMT_TOLERANCE_TYPE?.toLowerCase() !== "disable" && +(vendConfig?.INV_AMT_TOLERANCE_AT_CREATE_ASN) > 0) || checkAsnAmount(poDetails) != +value)) {
                if (vendConfig?.INV_AMT_TOLERANCE_TYPE?.toLowerCase() !== "disable" && +(vendConfig?.INV_AMT_TOLERANCE_AT_CREATE_ASN) > 0) {
                    if (showMessage) {
                        customToast({
                            title: "An Error Occured!",
                            description: `Warning : ${setInvoiceAmountRange()}`,
                            status: "error",
                        })
                    }
                } else {
                    if (showMessage) {
                        customToast({
                            title: "An Error Occured!",
                            description: `Warning : Invoice amount ${value} is not equal to ASN amount i.e. ${checkAsnAmount(poDetails)} for Requested Quantity`,
                            status: "error",
                        })
                    }
                }
            }
        }
    }

    const setInvoiceAmountRange = () => {
        let resultedCheckedAsnAmount = +showCheckAmount(poDetails);
        let inVoiceAmountRangeTolerance = 0;
        if (vendConfig?.INV_AMT_TOLERANCE_TYPE?.toLowerCase() === "percentage") {
            inVoiceAmountRangeTolerance = (resultedCheckedAsnAmount * +(vendConfig?.INV_AMT_TOLERANCE_AT_CREATE_ASN)) / 100;
        } else {
            inVoiceAmountRangeTolerance = +(vendConfig?.INV_AMT_TOLERANCE_AT_CREATE_ASN);
        }
        let upperLimit = +(vendConfig?.INV_AMT_TOLERANCE_AT_CREATE_ASN) && (resultedCheckedAsnAmount + inVoiceAmountRangeTolerance).toFixed(2);
        let lowerLimit = +(vendConfig?.INV_AMT_TOLERANCE_AT_CREATE_ASN) && (resultedCheckedAsnAmount - inVoiceAmountRangeTolerance).toFixed(2);
        if (upperLimit && lowerLimit && upperLimit > 0 && lowerLimit > 0 && vendConfig?.INV_AMT_TOLERANCE_TYPE?.toLowerCase() !== "disable") {
            return `Invoice amount should be in range between ${lowerLimit} - ${upperLimit}`
        } else {
            return Number(resultedCheckedAsnAmount || "") != Number(formData?.["invoiceAmount"] || "") ? `Invoice amount is not equal to ASN amount i.e. ${resultedCheckedAsnAmount} for Requested Quantity` : ""
        }
    }

    const handleCheckInvoiceQty = (e, blur, showMessage) => {
        let value = e.target.value, poDetailsData = JSON.parse(JSON.stringify(poDetails));
        let checkQty = poDetailsData?.reduce((n, { newRequestedQty }) => n + Number(newRequestedQty), 0);
        if ((e.key == "Enter" || blur == "blur")) {
            if (vendConfig?.INVOICE_UPLOAD_AT_CREATE_ASN?.toLowerCase() === "true" && vendConfig?.VALIDATE_INV_AND_ASN_AMT === "Warn" && value != checkQty) {
                if (showMessage) {
                    customToast({
                        title: "An Error Occured!",
                        description: `Invoice Quantity is not equal i.e ${checkQty} to Requested Quantity`,
                        status: "error",
                    })
                }
            }
            // else if (vendConfig?.INVOICE_UPLOAD_AT_CREATE_ASN?.toLowerCase() === "true" && vendConfig?.VALIDATE_INV_AND_ASN_AMT === "Restrict") {
            //     this.setState(prevState => ({
            //         inputErrors: {
            //             ...prevState.inputErrors,
            //             validateInvoiceQty: +value == checkQty ? false : true,
            //         },
            //     }));
            // }
        }
    }

    const handleClear = (key) => {
        switch (key) {
            case "shipmentRequestDate": {
                let data = { ...formData };
                data.shipmentRequestDate = "";
                data.qcFromDate = "";
                data.qcToDate = "";
                setFormData(data)
            }
                break;
            case "qcFromDate": {
                let data = { ...formData };
                data.qcFromDate = "";
                data.qcToDate = "";
                setFormData(data)
            }
                break;
        }
    }

    const handleClearDate = (key, data) => {
         switch (key) {
            case "shipmentRequestDate": {
                let updatedData = { ...data?.data || {} };
                updatedData.qcFromDate = "";
                updatedData.qcToDate = "";
                return updatedData;
            }
            case "qcFromDate": {
                let updatedData = { ...data?.data || {} };
                updatedData.qcToDate = "";
                return updatedData;
            }
        }
    }

    const isPoNonSet = () => {
        return selectedData?.poType?.toLowerCase() == "poicode" ? true : false
    }

    const handleEligbleASN = (checked) => {
        const poData = checked
            // ? originalPoDetails.filter(item => item?.isPoItemHold !== true)
            ? originalPoDetails.filter(item => {
                if (item?.tnaCompleted !== undefined) {
                    return item?.isPoItemHold !== true && item?.tnaCompleted === true;
                }
                return item?.isPoItemHold !== true;
            })
            : originalPoDetails;
        setOriginalPoDetails(prev => prev.length > poDetails.length ? prev : poDetails);
        setPoDetails(poData);
        setCheckEligibleASN(checked);
    };

    const getInputProps = (key) => {
        let commonProps = {
            viewDataType: "table-view",
            modalMainClass: "use-as-generic-dropdown",
            search: {
                placeholder: `Search...`
            },
        };
        switch (key) {
            case "address": return ({
                ...commonProps,
                modalMainClass: "use-as-generic-dropdown !max-w-[500px]",
                getListData: (response) => {
                    return response?.resource
                },
                api: {
                    reduxState: "digivendStore",
                    apiName: "vendFindAllAddress",
                    apiPayload: (params) => {
                        return {
                            type: params.currentSearch ? 3 : 1,
                            pageNo: params.currentPage || 1,
                            search: params.currentSearch || "",
                            sortedBy: "",
                            sortedIn: ""
                        }
                    },
                    getMaxPage: (states, fucntions, response) => {
                        return response?.maxPage
                    },
                    apiExtraHeaders: getPermissionKey("purchase", "shipment", isEdit ? "update" : "create")
                },
                headerKeys: {
                    shortName: { value: "Short Name" },
                    email: { value: "Email" },
                    address: { value: "Address Line 1" },
                    addressLine1: { value: "Address Line 2" },
                    city: { value: "City" },
                    state: { value: "State" },
                    country: { value: "Country" },
                    zipCode: { value: "ZipCode" },
                    contactPerson: { value: "Contact Person" },
                    contactNumber: { value: "Contact Number" },
                },
                itemKeys: {
                    shortName: ["shortName"],
                    email: ["email"],
                    address: ["address"],
                    addressLine1: ["addressLine1"],
                    city: ["city"],
                    state: ["state"],
                    country: ["country"],
                    zipCode: ["zipCode"],
                    contactPerson: ["contactPerson"],
                    contactNumber: ["contactNumber"],
                }
            })
            case "location": return ({
                ...commonProps,
                modalMainClass: "use-as-generic-dropdown !max-w-[500px]",
                getListData: (response) => {
                    return response?.resource
                },
                api: {
                    reduxState: "digivendStore",
                    apiName: "vendFindAllLocation",
                    apiPayload: (params) => {
                        return {
                            type: params.currentSearch ? 3 : 1,
                            pageNo: params.currentPage || 1,
                            search: params.currentSearch || "",
                            sortedBy: "",
                            sortedIn: ""
                        }
                    },
                    getMaxPage: (states, fucntions, response) => {
                        return response?.maxPage
                    },
                    apiExtraHeaders: getPermissionKey("purchase", "shipment", isEdit ? "update" : "create")
                },
                headerKeys: {
                    baseLocation: { value: "Insp. Base Location" },
                    shortName: { value: "Insp. Location Short Name" },
                    email: { value: "Email" },
                    contactPerson: { value: "Contact Person" },
                    contactNo: { value: "Contact Number" },
                },
                itemKeys: {
                    baseLocation: ["baseLocation"],
                    shortName: ["shortName"],
                    email: ["email"],
                    contactPerson: ["contactPerson"],
                    contactNo: ["contactNo"],
                },
            })
            case "getPoDetails": return ({
                ...commonProps,
                modalMainClass: "use-as-generic-dropdown",
                // isListItemDisabled: (item) => item?.item?.orderNumber == selectedData?.orderNumber || item?.item?.asnHoldCheck == 1,
                getListData: (response) => response?.resource?.filter((item) => item?.orderNumber !== selectedData?.orderNumber && item?.asnHoldCheck !== 1),
                api: {
                    reduxState: "generalStore",
                    apiName: "getTableComponentFifthList",
                    apiPayload: (params) => {
                        return {
                            type: 1,
                            pageNo: params.currentPage || 1,
                            search: params.currentSearch || "",
                            sortedBy: "",
                            sortedIn: "",
                            apiUrl: "/purchase/order/get/pending/order/data",
                            baseUrl: CONFIG.SM_BACKEND_BASE_URL,
                            displayName: "VENDOR_PENDING_ALL",
                            filter: {},
                            pageSize: 10,
                            status: "APPROVED"
                        }
                    },
                    getMaxPage: (states, fucntions, response) => {
                        return response?.maxPage
                    },
                    apiExtraHeaders: getPermissionKey("purchase", "orders", "view")
                },
                headerKeys: {
                    orderNumber: { value: "Order Number" }
                },
                itemKeys: {
                    orderNumber: [(_x, _y, data) => {
                        const isNonSet = data?.poSetType?.toLowerCase?.() === "non-set";
                        return (
                            <span className="flex items-center justify-between gap-1">
                                <span className="whitespace-nowrap text-[12px] ml-2">{data?.orderNumber}</span>
                                <span className={`text-[11px] font-semibold leading-[1.28] px-[3.5px] rounded-[3px] border-[1.5px] ${isNonSet ? "text-[#FF793F] border-[#FF793F]" : "text-[#1B9CFC] border-[#1B9CFC]"}`}>
                                    {isNonSet ? "N" : "S"}
                                </span>
                            </span>
                        );
                    }]
                },
            })
            case "transporter": return ({
                ...commonProps,
                getListData: (response) => {
                    return response?.resource
                },
                api: {
                    reduxState: "digivendStore",
                    apiName: "getAllTransporters",
                    apiPayload: (params) => {
                        return {
                            type: params.currentSearch ? 3 : 1,
                            pageNo: params.currentPage || 1,
                            search: params.currentSearch || "",
                            slCode: selectedData?.vendorCode
                        }
                    },
                    getMaxPage: (states, fucntions, response) => {
                        return response?.maxPage
                    },
                    apiExtraHeaders: getPermissionKey("purchase", "shipment", isEdit ? "update" : "create")
                },
                headerKeys: {
                    transporterCode: { value: "Transporter/Courier Co. Code" },
                    transporterName: { value: "Transporter/Courier Co. Name" },
                },
                itemKeys: {
                    transporterCode: ["transporterCode"],
                    transporterName: ["transporterName"],
                },
            })
            case 'packingList': return ({
                labelData: {
                    header: "Upload Packing List",
                },
                multipleFileUpload: true,
                maxSize: 5,
                fileUploadActionName: "finalSubmit",
                fileKeys: ["oldFileName", "", "url"],
                deleteImgFromServer: deleteImgFromServer,
                updateImageState: updateImageState,
                api: {
                    reduxState: "digivendStore",
                    apiName: "uploadUtilityDocument",
                    apiPayload: (files, removedFiles) => {
                        let formData = new FormData();
                        files?.map(file => {
                            formData.append("file", file);
                        })
                        formData.append('documentId', 0);
                        formData.append('type', "PACKAGING");
                        formData.append('requestId', !isDraftCreationInAsnAllowed() ? isNewMethodAllowed() ? `${uuId}-Draft1` : uuId : `${uuId}-${getCurrentKeyForRequestId()}`);
                        return formData;
                    },
                    apiExtraHeaders: getPermissionKey("common", "commonFunctionality", "upload")
                },
            })
            case 'ppsDoc': return ({
                labelData: {
                    header: "Upload PPS Doc",
                },
                multipleFileUpload: true,
                maxSize: 5,
                fileUploadActionName: "finalSubmit",
                fileKeys: ["fileName", "", "url"],
                deleteImgFromServer: deleteImgFromServer,
                updateImageState: updateImageState,
                api: {
                    reduxState: "digivendStore",
                    apiName: "uploadUtilityDocument",
                    apiPayload: (files, removedFiles) => {
                        let formData = new FormData();
                        files?.map(file => {
                            formData.append("file", file);
                        })
                        formData.append('documentId', 0)
                        formData.append('type', "PPS");
                        formData.append('requestId', !isDraftCreationInAsnAllowed() ? isNewMethodAllowed() ? `${uuId}-Draft1` : uuId : `${uuId}-${getCurrentKeyForRequestId()}`);
                        return formData;
                    },
                    apiExtraHeaders: getPermissionKey("common", "commonFunctionality", "upload")
                },
            })
            case 'testReport': return ({
                labelData: {
                    header: "Upload Test Report",
                },
                multipleFileUpload: true,
                maxSize: 5,
                fileUploadActionName: "finalSubmit",
                fileKeys: ["fileName", "", "url"],
                deleteImgFromServer: deleteImgFromServer,
                updateImageState: updateImageState,
                api: {
                    reduxState: "digivendStore",
                    apiName: "uploadUtilityDocument",
                    apiPayload: (files, removedFiles) => {
                        let formData = new FormData();
                        files?.map(file => {
                            formData.append("file", file);
                        })
                        formData.append('documentId', 0)
                        formData.append('type', "REPORT")
                        formData.append('requestId', !isDraftCreationInAsnAllowed() ? isNewMethodAllowed() ? `${uuId}-Draft1` : uuId : `${uuId}-${getCurrentKeyForRequestId()}`);
                        return formData;
                    },
                    apiExtraHeaders: getPermissionKey("common", "commonFunctionality", "upload")
                },
            })
            case 'invoiceUpload': return ({
                labelData: {
                    header: "Upload Invoice",
                },
                multipleFileUpload: true,
                maxSize: 5,
                fileUploadActionName: "finalSubmit",
                maxFiles: 1,
                showMaxFileUploadError: true,
                fileKeys: ["fileName", "", "url"],
                deleteImgFromServer: deleteImgFromServer,
                updateImageState: updateImageState,
                api: {
                    reduxState: "digivendStore",
                    apiName: "uploadUtilityDocument",
                    apiPayload: (files, removedFiles) => {
                        let formData = new FormData();
                        files?.map(file => {
                            formData.append("file", file);
                        })
                        formData.append('documentId', 0)
                        formData.append('type', "INVOICE");
                        formData.append('requestId', !isDraftCreationInAsnAllowed() ? isNewMethodAllowed() ? `${uuId}-Draft1` : uuId : `${uuId}-${getCurrentKeyForRequestId()}`);
                        return formData;
                    },
                    apiExtraHeaders: getPermissionKey("common", "commonFunctionality", "upload")
                },
            })
            case 'creditNote': return ({
                labelData: {
                    header: "Upload Credit Note",
                },
                multipleFileUpload: true,
                maxSize: 5,
                fileUploadActionName: "finalSubmit",
                // Only a single credit note can be uploaded
                maxFiles: 1,
                showMaxFileUploadError: true,
                fileKeys: ["fileName", "", "url"],
                deleteImgFromServer: deleteImgFromServer,
                updateImageState: updateImageState,
                api: {
                    reduxState: "digivendStore",
                    apiName: "uploadUtilityDocument",
                    apiPayload: (files, removedFiles) => {
                        let formData = new FormData();
                        files?.map(file => {
                            formData.append("file", file);
                        })
                        formData.append('documentId', 0)
                        formData.append('type', "SHIPMENT_CREDIT_NOTE");
                        formData.append('requestId', !isDraftCreationInAsnAllowed() ? isNewMethodAllowed() ? `${uuId}-Draft1` : uuId : `${uuId}-${getCurrentKeyForRequestId()}`);
                        return formData;
                    },
                    apiExtraHeaders: getPermissionKey("common", "commonFunctionality", "upload")
                },
            })
            case "stockRediness": return ({
                ...commonProps,
                search: false,
                headerKeys: {
                    "stockRediness": { value: "Stock Readiness" }
                },
                modalMainClass: "stock-readiness-dropdown",
                itemKeys: { "stockRediness": ["stockRediness"] },
                getListData: () => (localDropdownData?.["STOCK_READINESS"]?.map(item => ({ "stockRediness": item?.displayName, ...item }))),
            })
            case "brandLabel": return ({
                ...commonProps,
                search: false,
                headerKeys: {
                    "brandLabel": { value: "Brand Label" }
                },
                itemKeys: { "brandLabel": ["brandLabel"] },
                getListData: () => (localDropdownData?.["BRAND_LABEL"]?.map(item => ({ "brandLabel": item?.displayName, ...item }))),
            })
            case "barcodeStatus": return ({
                ...commonProps,
                search: false,
                headerKeys: {
                    "barcodeStatus": { value: "Barcode Status" }
                },
                itemKeys: { "barcodeStatus": ["barcodeStatus"] },
                getListData: () => (localDropdownData?.["BARCODE_STATUS"]?.map(item => ({ "barcodeStatus": item }))),
            })
            case "barcodeType": return ({
                ...commonProps,
                search: false,
                headerKeys: {
                    "barcodeType": { value: "Barcode Type" }
                },
                itemKeys: { "barcodeType": ["barcodeType"] },
                getListData: () => (localDropdownData?.["BARCODE_TYPE_ASN"]?.map(item => ({ "barcodeType": item }))),
            })
            case "cartonSize": return ({
                ...commonProps,
                search: false,
                headerKeys: {
                    "cartonSize": { value: "Cartoon Size" }
                },
                itemKeys: { "cartonSize": ["cartonSize"] },
                getListData: () => (localDropdownData?.["CARTON_SIZE"]?.map(item => ({ "cartonSize": item }))),
            })
            case "udfString01": return ({
                ...commonProps,
                search: false,
                // modalMainClass: "!top-[37px]",
                modalMainClass: "!min-h-[auto] !top-[calc(100%+4px)]",
                headerKeys: {
                    "udfString01": { value: "" }
                },
                itemKeys: { "udfString01": ["udfString01"] },
                getListData: () => (localDropdownData?.["OUT_OF_STOCK"]?.map(item => ({ "udfString01": item?.displayName }))),
            })
            case "shipmentPackingType": {
                return ({
                    ...commonProps,
                    search: false,
                    // modalMainClass: "!top-[37px]",
                    modalMainClass: "!min-h-[auto] !top-[calc(100%+4px)]",
                    headerKeys: {
                        "shipmentPackingType": { value: "" }
                    },
                    itemKeys: { "shipmentPackingType": ["shipmentPackingType"] },
                    getListData: () => ([
                        { "shipmentPackingType": "Cross Dock (XD) Cartons ASN", key: "cross" },
                        !isPoNonSet() && { "shipmentPackingType": "Set Cartons ASN", key: "set" },
                        { "shipmentPackingType": "Loose Cartons ASN", key: "loose" },
                    ]?.filter(item => Boolean(item)))
                })
            }
        }
    }

    let isAllQtyZeroRef = useRef(null);

    const handleTabChange = (tab, callCreateBoxesFunction = true) => {
        setCurrentTab(tab);
        if (tab === "createBox" && callCreateBoxesFunction) {
            createBoxes("throwTabChange");
            if(!state.mixedBoxesAllowedInThisPo){
                setIsAllQtyZero(true);
            }
        }else{
            setIsAllQtyZero(false);
        }
    }

    // useEffect(() => {
    //     if (currentTab === "createBox") {
    //         createBoxes();
    //     }
    // }, [currentTab])

    const checkAsnAmount = (poDetails) => {
        let totalAmount = 0, totalBaseAmount = 0, poType = selectedData?.poType

        if (poType === "poicode") {
            poDetails.map((item) => {
                totalBaseAmount = (item.newRequestedQty * item.rate) + ((item.gst / item.orderQty) * item.newRequestedQty)
                totalAmount = totalAmount + Number(totalBaseAmount)
            });
        } else {
            poDetails.map((item) => {
                totalBaseAmount = ((Number(item.setValue) + (Number(item?.gst || "") || 0)) * item.newRequestedQty * item.singleSetQty) / (item.setOrderQty)
                totalAmount = totalAmount + Number(totalBaseAmount)
            });
        }

        if (currentTab === "createBox" && vendConfig?.VALIDATE_INV_AND_ASN_AMT?.toLowerCase() !== "auto") {
            let boxesData = JSON.parse(JSON.stringify(boxes)), result = 0
            boxesData && boxesData?.map((box) => {
                result += +box.boxCount
            })
            setFormData({
                ...formData,
                unitCount: result
            });
            setcallErrroValidationFun(true)
        }

        if (vendConfig?.VALIDATE_INV_AND_ASN_AMT?.toLowerCase() === "auto") {
            let checkQty = poDetails.reduce((n, { newRequestedQty }) => n + Number(newRequestedQty), 0);
            let formDataClone = { ...formData };
            formDataClone.invoiceAmount = (+totalAmount).toFixed(2);
            formDataClone.invoiceQuantity = checkQty;
            if (currentTab === "createBox") {
                let boxesData = JSON.parse(JSON.stringify(boxes)), result = 0
                boxesData && boxesData?.map((box) => {
                    result += +box.boxCount
                });
                formDataClone.unitCount = result
            }
            setCallBackFun({ funName: "setFormData", value: formDataClone, setcallErrroValidationFun: true })
        }
        return totalAmount.toFixed(2)
    }

    const showCheckAmount = (poDetails) => {
        let totalAmount = 0, totalBaseAmount = 0, poType = selectedData?.poType

        if (poType === "poicode") {
            poDetails.map((item) => {
                totalBaseAmount = (item.newRequestedQty * item.rate) + ((item.gst / item.orderQty) * item.newRequestedQty)
                totalAmount = totalAmount + Number(totalBaseAmount)
            });
        } else {
            poDetails.map((item) => {
                totalBaseAmount = ((Number(item.setValue) + (Number(item?.gst || "") || 0)) * item.newRequestedQty * item.singleSetQty) / (item.setOrderQty)
                totalAmount = totalAmount + Number(totalBaseAmount)
            });
        }
        return totalAmount?.toFixed(2)
    }

    useEffect(() => {
        if (callBackFun?.funName == "setFormData") {
            setFormData(callBackFun?.value)
            setCallBackFun({ funName: "", value: "" })
            if (currentTab == "createBox" && !callBackFun?.setcallErrroValidationFun) {
                setcallErrroValidationFun(true);
            }
        }
    }, [callBackFun]);

    // Shared extraction so both tolerance helpers stay in sync.
    // checkQty: the base quantity (order qty for poicode, set count otherwise).
    // reqQty: quantity already requested — for edits it's derived from the
    // initial available qty, otherwise from the requested qty fields.
    const getRowToleranceInputs = (rowItem) => {
        const { tolerancePercentage = 0, orderQty = 0, totalNoOfSet = 0, qtyInputType = "I", setRequestedQty = 0, totalRequestedQty = 0, initialAvaliableQty, initialCancelQty = 0 } = rowItem || {};
        const isPoicode = selectedData?.poType === "poicode";
        const checkQty = Number(isPoicode ? orderQty : totalNoOfSet) || 0;
        const reqQty = isEdit
            ? checkQty - Number(initialAvaliableQty || 0)
            : Number(isPoicode ? totalRequestedQty : setRequestedQty) || 0;
        return { checkQty, reqQty, qtyInputType, tolerancePercentage: Number(tolerancePercentage) };
    };

    const getRowAvailableQtyBasedOnTolerancePer = (rowItem) => {
        const { checkQty, reqQty, qtyInputType, tolerancePercentage } = getRowToleranceInputs(rowItem);
        const tolPerVal = (checkQty / 100) * tolerancePercentage;
        // Available qty = base + full tolerance − already requested
        // (tolerance is rounded only when the input is integer-based).
        console.log("ew4343344", checkQty, reqQty, qtyInputType, tolerancePercentage)
        return qtyInputType === "I" ? (checkQty + Math.floor(tolPerVal)) - reqQty : (checkQty + tolPerVal) - reqQty;
    };

    const getRowTolerancePerValue = (rowItem) => {
        const { checkQty, reqQty, qtyInputType, tolerancePercentage } = getRowToleranceInputs(rowItem);
        // Remaining tolerance: once requested qty exceeds the base, it eats into
        // the tolerance pool; otherwise the full tolerance is still available.
        const tolPerVal = reqQty > checkQty
            ? ((checkQty / 100) * tolerancePercentage + checkQty) - reqQty
            : (checkQty / 100) * tolerancePercentage;
        return qtyInputType === "I" ? Math.floor(tolPerVal) : tolPerVal;
    };

    const handleQtyInput = (e, qtyInputType = "I", otherDetails) => {
        const field = e?.target?.name, index = e?.target?.dataset?.index,
            value = (field === "boxWeight" && e?.target?.value.endsWith(".") && !Number.isNaN(e?.target?.value)) ? e.target.value : e.target.value;
        let result = !Number.isNaN(value) && qtyInputType ? qtyInputType === "I" ? allowOnlyNumbers(value) : uptoTwoDecimalRegex(value) : true
        if (result) {
            let poDetailsData = [...poDetails], boxesData = JSON.parse(JSON.stringify(boxes));
            setConfirmationModalShow(true);
            switch (field) {
                case "newRequestedQty": {
                    poDetailsData[index].newRequestedQty = +value; // ensure it's a number
                    if (isEdit) {
                        // Adjust pending qty properly if needed
                        poDetailsData[index].setPendingQty = poDetailsData[index].totalAvaliableQty - Number(poDetailsData[index].newRequestedQty)
                    } else {
                        poDetailsData[index].setPendingQty = poDetailsData[index].availableQty - poDetailsData[index].newRequestedQty;
                    }

                    // Round to 2 decimals
                    poDetailsData[index].setPendingQty = parseFloat(poDetailsData[index].setPendingQty.toFixed(2));

                    // Reset newCancelledQty
                    poDetailsData[index].newCancelledQty = 0;
                    if (isEdit) {
                        if (Number(value) > getRowAvailableQtyBasedOnTolerancePer(poDetailsData[index])) {
                            poDetailsData[index].maxQtyError = `Request Qty must not exceed ${getRowAvailableQtyBasedOnTolerancePer(poDetailsData[index])}`;
                        }
                        else poDetailsData[index].maxQtyError = "";
                    }
                    else {
                        if (Number(value) > getRowAvailableQtyBasedOnTolerancePer(poDetailsData[index])) {
                            poDetailsData[index].maxQtyError = `Request Qty must not exceed ${getRowAvailableQtyBasedOnTolerancePer(poDetailsData[index])}`;
                        }
                        else poDetailsData[index].maxQtyError = "";
                    }
                    checkAsnAmount(poDetails)
                    break;
                }
                case "newCancelledQty": {
                    const availableQty = getRowAvailableQtyBasedOnTolerancePer(poDetailsData[index]);
                    const totalRequested = Number(poDetailsData[index].newRequestedQty || 0);
                    const totalCancelled = Number(value || 0);

                    if (totalRequested + totalCancelled <= availableQty) {
                        poDetailsData[index].newCancelledQty = value;
                        poDetailsData[index].setPendingQty = availableQty - totalRequested - totalCancelled;

                        setPoDetails([...poDetailsData]); // to trigger re-render
                        setOriginalPoDetails([...poDetailsData])
                    }

                    // if (value <= poDetailsData[index].setPendingQty) {
                    //     poDetailsData[index].newCancelledQty = value;
                    //     poDetailsData[index].setPendingQty = getRowAvailableQtyBasedOnTolerancePer(poDetailsData[index]) - poDetailsData[index].newRequestedQty - poDetailsData[index].newCancelledQty;
                    //     // rounding decimal values
                    //     if ((poDetailsData[index].setPendingQty - Math.floor(poDetailsData[index].setPendingQty)) !== 0) {
                    //         poDetailsData[index].setPendingQty = (Math.floor(poDetailsData[index].setPendingQty * 100) / 100).toFixed(2)
                    //     }
                    //     setPoDetails(poDetailsData)
                    // }
                    break;
                }
                case "boxCount": {
                    boxesData[index].boxCount = value;

                    // Check for the box count error 
                    if (poDetailsResponse?.boxTemplateConfig && boxesData?.[0]?.boxTemplate) {
                        if (boxesData?.[index]?.boxCount > (boxesData?.[index]?.boxTemplate?.box_count || 1)) {
                            boxesData[index].boxCountError = `Box Count cannot be greater than ${boxesData?.[index]?.boxTemplate?.box_count || "1"}.`
                        } else if (boxesData[index].boxCountError) {
                            delete boxesData[index].boxCountError;
                        }
                    }

                    break;
                }
                case "boxWeight": {
                    if (otherDetails?.allowMultipleValueUpdateAtOnce) {
                        boxesData = boxesData?.map((innerVal, innerIndex) => {
                            return {
                                ...innerVal,
                                boxWeight: otherDetails?.boxesData?.[innerIndex]?.totalWeight
                            }
                        })
                    }
                    else {
                        boxesData[index].boxWeight = value;
                    }
                    weightError(boxesData)
                    break;
                }
                case "addLength": {
                    poDetailsData[index].length = value;
                    break;
                }
                case "addBreadth": {
                    poDetailsData[index].breadth = value;
                    break;
                }
                case "addHeight": {
                    poDetailsData[index].height = value;
                    break;
                }
                case "addWeight": {
                    poDetailsData[index].weight = value;
                    break;
                }
            }

            // Check for percentage criteria and if newRequestedQty can be 0
            let overallRequestedQty = 0, overallAvailableQty = 0, overallOrderPercentage = 0;
            poDetailsData?.forEach(item => {
                if (item.newRequestedQty > 0) {
                    overallAvailableQty += item.availableQty;
                    overallRequestedQty += +item.newRequestedQty;
                }
            });
            overallOrderPercentage = (overallRequestedQty / overallAvailableQty) * 100;
            let rowPerValue = (Number(poDetailsData?.[index]?.newRequestedQty) / poDetailsData?.[index]?.availableQty) * 100;
            if (poDetailsData?.[index]?.newRequestedQty && poDetailsData?.[index]?.consumptionConfigValue && rowPerValue < Number(poDetailsData?.[index]?.consumptionConfigValue)) {
                poDetailsData[index].minQtyError = `Request Qty must be at least ${poDetailsData?.[index]?.consumptionConfigValue}% of ${poDetailsData?.[index].availableQty}`;
            }
            else if (poDetailsData?.[index]?.consumptionConfigValue && poDetailsData[index].minQtyError) {
                poDetailsData[index].minQtyError = "";
            }

            let overallRequestedQtyError = "";
            if (vendConfig?.asnCreationFulfilmentRequired?.toLowerCase() === "true") { // Percentage criteria is applicable
                if (vendConfig?.cancelLinePendingQty?.toLowerCase() === "true") { // newRequestedQty can be 0 for some rows
                    if (overallOrderPercentage < Number(vendConfig?.asnCreationFulfilment)) {
                        overallRequestedQtyError = `Total Request Qty must be at least ${vendConfig?.asnCreationFulfilment}% of ${overallAvailableQty}`;
                    }
                    else overallRequestedQtyError = "";
                }
                // newRequestedQty cannot be 0 for any row        
                poDetailsData?.forEach(item => {
                    if (Number(item.availableQty) > 0 && Number(item?.newRequestedQty) > 0) {
                        let minRequiredPercentage = Math.max(
                            Number(item?.consumptionConfigValue || 0),
                            Number(vendConfig?.asnCreationFulfilment || 0)
                        );
                        const orderPercentage = (Number(item.newRequestedQty) / item.availableQty) * 100;
                        if (orderPercentage < minRequiredPercentage) {
                            item.minQtyError = `Request Qty must be at least ${minRequiredPercentage}% of ${item.availableQty}`;
                        }
                        else item.minQtyError = ""
                    }
                    else item.minQtyError = ""
                });
            }
            else {
                if (!overallRequestedQty) {
                    overallRequestedQtyError = "Total Request Qty cannot be 0";
                }
                else overallRequestedQtyError = "";
            }

            setBoxes(boxesData);
            setPoDetails(poDetailsData)
            setOriginalPoDetails(poDetailsData)
            setState({
                ...state,
                overallRequestedQtyError: overallRequestedQtyError
            })
            setUpdateReqQtyCallBack(field);
        }
        // checkCartonNumber();
    }

    const [updateReqQtyCallBack, setUpdateReqQtyCallBack] = useState('')

    useEffect(() => {
        if (updateReqQtyCallBack === "boxCount") {
            setUpdateReqQtyCallBack('');
            updateRequestedQty();
        }
    }, [updateReqQtyCallBack])

    const handleCheckInvoiceQtyBottom = (e, blur, showMessage) => {
        let value = e?.target?.value, poDetailsData = [...poDetails]
        let checkQty = poDetailsData?.reduce((n, { newRequestedQty }) => n + Number(newRequestedQty), 0);
        if ((e.key == "Enter" || blur == "blur")) {
            if (vendConfig?.INVOICE_UPLOAD_AT_CREATE_ASN?.toLowerCase() === "true" && vendConfig?.VALIDATE_INV_AND_ASN_AMT?.toLowerCase() === "warn" && value != checkQty) {
                if (showMessage) {
                    customToast({
                        title: "An Error Occured!",
                        description: `Invoice Quantity is not equal i.e ${checkQty} to Requested Quantity`,
                        status: "error",
                    });
                }
            }
        }
    }

    const small = (str) => {
        if (str != null) {
            var str = str?.toString()
            if (str.length <= 30) {
                return false;
            }
            return true;
        }
    }

    const handleExpand = (item) => {
        if(item?.isPoItemHold || item?.tnaCompleted===false) return
        if (!digiVendStore?.vendorshipFindSrdetailData?.isLoading && !digiVendStore?.vendorpoGetPodetailData?.isLoading) {
            if (!expandedSetRow || expandedSetRow.id != item.id) {
                setExpandedSetRow(item)
                setState({ ...state })
                setCallConfirmatioFun(false);
            }
            else {
                setExpandedSetRow(false)
                setState({ ...state })
                setCallConfirmatioFun(false);
            }
        }
    }

    function getSkuCountByIndex(data, index) {
        let count = 0;

        for (let key in data) {
            if (data[key][index] !== null && data[key][index] != "0") {
                count++;
            }
        }

        return count;
    }

    // Function : To check for the input that is available or not
    const isShipmentTypeIsAvailable = () => {
        // Check if the input is available oir not 
        let displayCheck = isEdit ? "isDisplayOnEditVendor" : "isEditableVendor";
        if (formSettings?.["shipmentPackingType"]?.[displayCheck]) {
            return true
        }
    }

    const getArticleIcodeMapping = () => {
        let articleIcodeMapping = {}

        poDetails?.map(item => {
            if (item?.[isPoNonSet() ? "itemCode" : "setBarCode"]) {
                articleIcodeMapping = {
                    ...articleIcodeMapping,
                    [item?.[isPoNonSet() ? "itemCode" : "setBarCode"]]: item?.["hl4Code"]
                }
            }
        })

        return articleIcodeMapping;
    }

    const handleSKUWiseInput = (e, code, qty, indx) => {
        let condition = openedModal === "scanNPack";
        const sku = condition ? code : e?.target?.dataset?.sku, value = condition ? qty : e?.target?.value, index = condition ? indx : e?.target?._excelIndex || state?.addSKUModal;
        // _excelIndex will be available only at the time of excel upload
        // console.log("check for the same article", code, sku, qty, index, poDetails, skuWiseBoxes, boxes)
        if (!Number.isNaN(value)) {
            if (isShipmentTypeIsAvailable?.()) {
                let skuWiseBoxesData = JSON.parse(JSON.stringify(skuWiseBoxes));
                if (formData?.["shipmentPackingType"]?.["shipmentPackingType"] == "Cross Dock (XD) Cartons ASN") {
                    // Check for the same article 
                    let articleIcodeMapping = getArticleIcodeMapping()
                    // Find the first article that is present inside current box;
                    let firstItemCodePresent = Object.keys(skuWiseBoxes || {})?.find((item) => skuWiseBoxes?.[item]?.[index] > 0);
                    let firstArticleCodePresent = articleIcodeMapping?.[firstItemCodePresent];
                    // One article code is present but the values are not same for the article code.
                    if (firstArticleCodePresent && firstArticleCodePresent != articleIcodeMapping?.[sku]) {
                        customToast({
                            title: "An Error Occured!",
                            description: `Only 1 article code is allowed per box for the PO!`,
                            status: "error",
                        });
                        return;
                    } else {
                        if (sku !== undefined) {
                            if (isEdit) skuWiseBoxesData[sku][index] = value || null;
                            else skuWiseBoxesData[sku][index] = value || null;
                        }
                    }
                }

                if (formData?.["shipmentPackingType"]?.["shipmentPackingType"] == "Set Cartons ASN") {
                    // Check for the same set barcode
                    // Find the first set barcode that is present in the current box.
                    let firstSetBarCodePresent = Object.keys(skuWiseBoxes || {})?.find((item) => skuWiseBoxes?.[item]?.[index] > 0);
                    if (firstSetBarCodePresent && sku != firstSetBarCodePresent) {
                        customToast({
                            title: "An Error Occured!",
                            description: `Only 1 set barcode is allowed per box for the PO!`,
                            status: "error",
                        });
                        return;
                    } else {
                        if (sku !== undefined) {
                            if (isEdit) skuWiseBoxesData[sku][index] = value || null;
                            else skuWiseBoxesData[sku][index] = value || null;
                        }
                    }
                } else {
                    if (sku !== undefined) {
                        if (isEdit) skuWiseBoxesData[sku][index] = value || null;
                        else skuWiseBoxesData[sku][index] = value || null;
                    }
                }
                setSkuWiseBoxes(skuWiseBoxesData)
            } else {
                let skuWiseBoxesData = JSON.parse(JSON.stringify(skuWiseBoxes));
                if (!state?.mixedBoxesAllowedInThisPo && !state?.mixedBoxesAllowed && !state?.mixedSKUPerBox && value &&
                    Object.keys(skuWiseBoxes).some(
                        key => key !== sku && skuWiseBoxes[key][index] !== null && skuWiseBoxes[key][index] !== undefined
                    )) {
                    customToast({
                        title: "An Error Occured!",
                        description: "Only 1 mixed SKU is allowed per box for the PO!",
                        status: "error",
                    });
                    return;
                }
                if (state?.mixedSKUPerBox) {
                    if (sku !== undefined) {
                        skuWiseBoxesData[sku][index] = value || null;
                    }
                    if (getSkuCountByIndex(skuWiseBoxesData, index) > +(vendConfig?.MIXED_SKU_CONFIG)) {
                        customToast({
                            title: "An Error Occured!",
                            description: `Only ${vendConfig?.MIXED_SKU_CONFIG} mixed SKU is allowed per box for the PO!`,
                            status: "error",
                        });
                        return;
                    }
                }
                if (sku !== undefined) {
                    if (isEdit) skuWiseBoxesData[sku][index] = value || null;
                    else skuWiseBoxesData[sku][index] = value || null;
                }
                else {
                    let id = selectedData?.poType === "poicode" ? "Item Code" : "Set BarCode";
                    customToast({
                        title: "An Error Occured!",
                        description: `${id} is not avaliable`,
                        status: "error",
                    });
                }
                setSkuWiseBoxes(skuWiseBoxesData)
            }
        }
    }

    const createBoxes = (tabChange) => {
        if (state?.weightMandatory !== "Mandatory" || (tabChange == "throwTabChange" && isEdit)) return;
        const poiCode = selectedData?.poType === "poicode" ? "N" : "S";
        let skuWiseBoxesData = JSON.parse(JSON.stringify(skuWiseBoxes));
        const itemCodekeys = Object.keys(skuWiseBoxesData);
        const sizeOfBoxes = itemCodekeys.length > 0 ? skuWiseBoxesData[itemCodekeys[0]].length : 0;
        let boxesData = [];

        for (let boxNo = 0; boxNo < sizeOfBoxes; boxNo++) {
            let obj = {
                totalRequestedQty: 0,
                selectedSKUS: [],
                totalWeight: 0,
            }
            itemCodekeys?.map((itemCode) => {
                let requestedQuantityArr = skuWiseBoxesData[itemCode]
                if (requestedQuantityArr[boxNo] && requestedQuantityArr[boxNo] > 0) {
                    let po = getPoUsingItemCode(itemCode, poiCode)[0];
                    let poWeight = po.weight ? +po.weight : 1;
                    obj.totalRequestedQty = obj.totalRequestedQty + (+requestedQuantityArr[boxNo]);
                    let perBoxWeight = poWeight ? (+requestedQuantityArr[boxNo] * poWeight) : 0;
                    obj.selectedSKUS.push({ itemCode: itemCode, requestedQty: +requestedQuantityArr[boxNo], perBoxWeight });
                    obj.totalWeight = obj.totalWeight + perBoxWeight;
                }
            })
            obj.totalWeight = (obj.totalWeight + (+state?.emptyCartonWeight)) / 1000;
            obj.selectedSKUS.length > 0 && boxesData.push(obj);
        }

        let newBoxes = JSON.parse(JSON.stringify(boxes));
        newBoxes?.map((b, i) => {
            let event = {
                target: {
                    name: "boxWeight",
                    dataset: {
                        index: i,
                    },
                    value: boxesData.length > i ? boxesData[i].totalWeight + "" : 0 + "",
                }
            }
            handleQtyInput(event, "", { allowMultipleValueUpdateAtOnce: true, boxesData });
        })

        setState({
            ...state,
            skuBoxesWeightWise: boxesData
        })
    }

    const getPoUsingItemCode = (id, poiCode) => {
        return poDetails?.filter(poD => poiCode === "N" && id === poD.id ? poD : id === poD.setBarCode && poD);
    }

    const updateRequestedQty = () => {
        // Calculate the quantities for all rows according to current input values
        poDetails.forEach((item, index) => {
            let newRequestedQty = skuWiseBoxes?.[item.id]?.reduce((prev, curr, innerIndex) => {
                if (curr !== null) {
                    return prev + Number(curr * boxes[innerIndex]?.boxCount)
                }
                else return prev;
            }, 0) || 0;

            handleQtyInput({
                target: {
                    name: "newRequestedQty",
                    value: newRequestedQty,
                    dataset: {
                        index: index
                    }
                }
            });
        });
        updateMultipleSku()
        weightError(boxes);
        createBoxes();
        setTimeout(() => {
            if (errorData?.unitCount?.length) {
                setcallErrroValidationFun(true);
            }
        }, 500);
    }

    const weightError = (boxes) => {
        setState({
            ...state,
            weightError: boxes.some(item => item.boxWeight <= 0)
        });
    }

    const updateMultipleSku = () => {
        let noOfSKUPerBox = {}
        boxes?.map((item, indexx) => {
            let noOfSKU = 0
            Object.values(skuWiseBoxes)?.forEach(int => {
                if (int[indexx] !== null) {
                    noOfSKU++;
                    noOfSKUPerBox = { ...noOfSKUPerBox, [indexx]: noOfSKU }
                }
            })
        })
        let counter = []
        Object.values(noOfSKUPerBox)?.map((item) => {
            if (item > 1) {
                counter.push(item)
            }
        })
        if (counter.length >= Number(state?.mixedSKUAllowedUpto)) {
            setState({
                ...state,
                mixedBoxesAllowed: false,
                noOfSKUPerBox: noOfSKUPerBox
            })
        }
        else {
            setState({
                ...state,
                mixedBoxesAllowed: false,
                noOfSKUPerBox: noOfSKUPerBox
            })
        }
    }

    const toggleAddSKUModal = (index) => {
        if (index !== -1 && state?.noOfSKUPerBox[index] > 1) {
            setState({
                ...state,
                mixedBoxesAllowed: true
            })
        }
        setState({
            ...state,
            addSKUModal: index
        })
    }

    const openSkuModal = (index) => {
        if (index !== -1 && state?.noOfSKUPerBox[index] > 1) {
            setState({
                ...state,
                mixedBoxesAllowed: true
            })
        }
        setState({
            ...state,
            addSKUModal: index
        })
        setOpenedModal("addSkus")
    }

    const [afterDiscardCallAction, setAfterDiscardCallAction] = useState(false);

    const deleteBox = (index) => {
        let skuWiseBoxesData = JSON.parse(JSON.stringify(skuWiseBoxes)), boxesData = JSON.parse(JSON.stringify(boxes)), noOfSKUPerBoxData = JSON.parse(JSON.stringify(state?.noOfSKUPerBox));
        skuWiseBoxesData && Object.keys(skuWiseBoxesData).forEach(item => {
            skuWiseBoxesData?.[item]?.splice(index, 1);
        });
        boxesData.splice(index, 1);
        delete noOfSKUPerBoxData?.[index];
        setState({
            ...state,
            noOfSKUPerBoxData: noOfSKUPerBoxData
        });
        setBoxes(boxesData);
        setSkuWiseBoxes(skuWiseBoxesData)
        setCallAfterDelete(true);
    }

    useEffect(() => {
        if (afterDiscardCallAction) {
            setAfterDiscardCallAction(false);
            if (openedModal === "scanNPack") {
                deleteBox(boxes.length - 1);
                setOpenedModal(false)
            }
            else if (Object.values(skuWiseBoxes).every(item => item[state?.addSKUModal] === null)) {
                deleteBox(state?.addSKUModal);
                toggleAddSKUModal(-1);
                setOpenedModal(false)
            }
            else {
                toggleAddSKUModal(-1);
                setOpenedModal(false)
            }
            updateMultipleSku();
        }
    }, [afterDiscardCallAction])

    const discardAddSKUModal = skuWiseBoxesVar => { // called when user wishes to close the AddSKUModal and discard any changes
        setSkuWiseBoxes(skuWiseBoxesVar);
        setAfterDiscardCallAction(true);
    }

    const [callAfterDelete, setCallAfterDelete] = useState(false)

    useEffect(() => {
        if (callAfterDelete) {
            setCallAfterDelete(false)
            updateRequestedQty();
        }
    }, [callAfterDelete]);

    const [addNewBoxAfterFun, setAddNewBoxAfterFun] = useState(false)

    const addNewBox = () => {
        updateRequestedQty();
        setOpenedModal(false);
        setAddNewBoxAfterFun(true);
    }

    useEffect(() => {
        if (addNewBoxAfterFun) {
            handleChange('scanNPack');
            setAddNewBoxAfterFun(false);
        }
    }, [addNewBoxAfterFun]);

    const deleteSku = (code) => {
        let skuWiseBoxesData = JSON.parse(JSON.stringify(skuWiseBoxes));
        skuWiseBoxesData[code].pop()
        if (skuWiseBoxesData[code].length == 0) {
            skuWiseBoxesData[code][0] = null
        }
        setSkuWiseBoxes(skuWiseBoxesData);
    }

    const formatDate = (value) => {
        if (!value) return "";

        let d = value?.$d ? dayjs(value.$d) : dayjs(value);
        // const d = dayjs.utc(value);

        if (!d.isValid()) return "";

        return d.format("YYYY-MM-DD") + "T00:00+05:30";
    };

    console.log("form data", localDropdownData, formData)

    // Function : To provide the final submit asn payload
    const getFinalAsnPayload = (config = {}) => {

        let {
            poDetails,
            formData,
            state,
            boxes,
            skuWiseBoxes,
        } = config;
        let hopscotchSchemaEntId = ["8534", "754"];

        let changelineitems = [],
            totalRequestQty = 0,
            basicLineAmount = 0,
            basicAmount = 0,
            taxAmount = 0,
            totalCancelledQty = 0,
            totalPendingQty = 0;

        changelineitems = poDetails?.map((item) => {
            let newRequestedQty = +item.newRequestedQty
            totalRequestQty += +newRequestedQty;
            totalCancelledQty += +item.newCancelledQty;
            totalPendingQty += +item.setPendingQty;
            basicLineAmount = Math.floor(item.rate) * newRequestedQty;
            basicAmount += +basicLineAmount;
            taxAmount += Math.floor(basicLineAmount * (item.gst / 100));
            return {
                orderDetailId: item.orderDetailId,
                setHeaderId: item.setHeaderId,
                requestedQty: newRequestedQty,
                orderQty: item.totalNoOfSet === undefined ? item.orderQty : item.totalNoOfSet,
                pendingQty: item.setPendingQty,
                cancelQty: item.newCancelledQty,
                weight: +item.weight,
                breadth: +item.breadth,
                height: +item.height,
                length: +item.length,
                tolerancePercentage: item?.tolerancePercentage || "0",
                udfString01: hopscotchSchemaEntId?.includes(tokenData?.schemaEntID) ? item?.udfString01 ?? undefined : undefined,
            };
        });

        let shipmentPackingType = formData?.shipmentPackingType?.shipmentPackingType ? formData?.shipmentPackingType?.shipmentPackingType : "";
        let brandLabel = formData?.brandLabel?.brandLabel ? formData?.brandLabel?.displayName ? formData?.brandLabel : localDropdownData?.["BRAND_LABEL"]?.find(item => item?.value == formData?.brandLabel?.value?.trim?.()) : {}
        console.log("brand label payload", brandLabel, formData?.brandLabel, localDropdownData?.["BRAND_LABEL"])
        let stockRediness = formData?.stockRediness?.stockRediness ? formData?.stockRediness?.displayName ? formData?.stockRediness : localDropdownData?.["STOCK_READINESS"]?.find(item => item?.value == formData?.stockRediness?.value) : {}
        let addressArray = [formData?.address?.address, formData?.address?.addressLine1, formData?.address?.zipCode, formData?.address?.shortName]
        let addressVal = formData?.address?.addressLine1 ? addressArray?.join(",") || "" : formData?.address?.address;
        let payload = {
            address: addressVal || "",
            basicAmount,
            contactNo: (formData?.contactNo === "+91" ? "" : formData?.contactNo) || "",
            contactPerson: formData?.contactPerson || "",
            documentNumber: selectedData?.documentNumber,
            invoiceNumber: formData?.invoiceNumber || "",
            transporterCode: formData?.transporter?.transporterCode || "",
            invoiceAmount: formData?.invoiceAmount || "",
            unitCount: formData?.unitCount || "",
            dueInDays: selectedData?.dueDays || "",
            enterpriseSite: selectedData?.siteDetails || "",
            // Upload Files
            isPackagingUploaded: formData?.packingList?.length ? "TRUE" : "FALSE",
            folderDirectoryPackaging: isEdit ? uploadedFileDirectory?.packingList || formData?.packingList?.[0]?.filePath || "" : formData?.packingList?.[0]?.filePath || "",
            folderDirectoryPPS: isEdit ? uploadedFileDirectory?.ppsDoc || formData?.ppsDoc?.[0]?.filePath || "" : formData?.ppsDoc?.[0]?.filePath || "",
            folderDirectoryReport: isEdit ? uploadedFileDirectory?.testReport || formData?.testReport?.[0]?.filePath || "" : formData?.testReport?.[0]?.filePath || "",
            folderInvoice: isEdit ? uploadedFileDirectory?.invoiceUpload || formData?.invoiceUpload?.[0]?.filePath || "" : formData?.invoiceUpload?.[0]?.filePath || "",
            isInvoiceUploaded: formData?.invoiceUpload?.length ? "TRUE" : "FALSE",
            isPPSAvailable: formData?.ppsDoc?.length ? "TRUE" : "FALSE",
            // End Of Upload Files
            isShipConfirmed: "FALSE",
            isTestReportAvailable: formData?.testReport?.length ? "TRUE" : "FALSE",
            location: formData?.location?.location || "",
            locationEmail: formData?.location?.email || "",
            orderCode: selectedData?.orderCode,
            orderId: selectedData?.orderId,
            orderNumber: selectedData?.orderNumber,
            poDetails: changelineitems,
            poType: selectedData?.poType,
            qcFromDate: formatDate(formData?.qcFromDate),
            qcToDate: formatDate(formData?.qcToDate),
            remarks: formData?.remarks || "",
            shipmentRequestDate: formatDate(formData?.shipmentRequestDate),
            invoiceDate: formatDate(formData?.invoiceDate),
            shipmentRequestOnDate: dayjs().format("YYYY-MM-DD") + "T00:00+05:30",
            shipmentTotalCancelledQty: totalCancelledQty,
            shipmentTotalRequestedQty: totalRequestQty,
            taxAmount,
            totalPendingQty: totalPendingQty,
            transporter: formData?.transporter?.transporterName ? formData?.transporter?.transporterName : selectedData?.transporterName,
            validFromDate: vendConfig?.asnFromToApplicablility?.toLowerCase() === "true" ? formatDate(selectedData?.asnFromSelectionDate) : formatDate(selectedData?.validFromSelectionDate),
            validToDate: vendConfig?.asnFromToApplicablility?.toLowerCase() === "true" ? formatDate(selectedData?.asnToSelectionDate) : formatDate(selectedData?.validToSelectionDate),
            vendorName: selectedData?.vendorName,
            boxPrefix: state?.boxPrefix,
            emptyCartonWeight: +state?.emptyCartonWeight,
            agentCode: formData?.agentCode || "",
            agentName: formData?.agentName || "",
            uuid: uuId,
            // Add the new keys for hobscotch
            brandLabel: getInputType("brandLabel") == "text" ? formData?.brandLabel : 
                (["8534", "754"].includes(tokenData?.schemaEntID?.toString()) ? // for hopscotch
                    (brandLabel?.displayName ? `${brandLabel?.displayName} || ${brandLabel?.value}` : "") : 
                    (brandLabel?.displayName || "")
                ),

            shipmentPackingType: shipmentPackingType || "",
            stockRediness: stockRediness?.displayName ? `${stockRediness?.displayName} ||${stockRediness?.value}` : (isClientHopscotch?.() && isEdit && formData?.stockRediness?.stockRediness) ? `${formData?.stockRediness?.stockRediness} ||${formData?.stockRediness?.value}` : "",
            barcodeStatus: formData?.barcodeStatus?.barcodeStatus || "",
            barcodeType:  getInputType("barcodeType") == "text" ?  formData?.barcodeType || "" : formData?.barcodeType?.barcodeType || "",
            cartonSize: formData?.cartonSize?.cartonSize || "",
            awbNumber: isNewMethodAllowed() ? formData?.awbNumber || "" : undefined,
            // Send the late delivery charge percentage only while creating (not on edit)
            lateDeliveryCharges: !isEdit && Number(selectedData?.lateDeliveryCharges ?? 0) > 0 ? Number(selectedData?.lateDeliveryCharges) : undefined,
            lateDeliveryChargesAccepted: !isEdit && Number(selectedData?.lateDeliveryCharges ?? 0) > 0 ? 1 : undefined,
            isCreditnoteUploaded: formData?.creditNote?.length ? 1 : 0
        };

        if (state?.boxCreation) {
            if (isEdit) {
                const skuWiseDetails = {};
                poDetails?.forEach(item => {
                    skuWiseDetails[item.id] = item;
                });
                payload.boxes = boxes?.map((item, index) => {
                    let skus = [];
                    Object.keys(skuWiseBoxes).forEach(key => {
                        if (skuWiseBoxes[key][index] && skuWiseBoxes[key][index] !== "0") {
                            skus.push({
                                po_details_id: skuWiseDetails?.[key]?.orderDetailId,
                                set_header_id: skuWiseDetails?.[key]?.setHeaderId,
                                qty: skuWiseBoxes?.[key]?.[index]
                            });
                        }
                    });
                    return {
                        box_id: item?.id || index + 1,
                        box_count: +(item.boxCount),
                        prev_box_count: item.prev_box_count,
                        box_weight: Number(item.boxWeight),
                        shipmentBoxId: item.shipmentBoxId,
                        boxNumber: item?.boxNumber || "",
                        boxTemplateId: item?.boxTemplate?.box_id || "",
                        skus
                    };
                });
            }
            else {
                const skuWiseDetails = {};
                poDetails?.forEach(item => {
                    skuWiseDetails[item.id] = item;
                });

                payload.boxes = boxes?.map((item, index) => {
                    let skus = [];
                    Object.keys(skuWiseBoxes).forEach(key => {
                        if (skuWiseBoxes[key][index] !== null) {
                            skus.push({
                                po_details_id: skuWiseDetails?.[key]?.orderDetailId,
                                set_header_id: skuWiseDetails?.[key]?.setHeaderId,
                                qty: skuWiseBoxes?.[key]?.[index],
                            });
                        }
                    });
                    return {
                        box_id: index + 1,
                        box_count: item.boxCount,
                        box_weight: Number(item.boxWeight),
                        boxTemplateId: item?.boxTemplate?.box_id || "",
                        skus
                    };
                });
            }
        }
        if (isEdit) {
            payload.shipmentAdviceCode = selectedData?.shipmentAdviceCode;
            payload.shipmentId = selectedData?.shipmentId;
        }

        return payload;

    }

    const exportExcelForThisPo = () => {

        let tableHeaders = props?.getTableHeadersPayload?.();
        let childKey = isPoNonSet?.() ? "item" : "set"
        let headersType = getHeadersType(props.headersDataRef?.current || {}, [childKey])
        let headersObject = {};
        [childKey]?.map(key => {
            headersObject = {
                ...headersObject,
                ...props.headersDataRef?.current?.[key]?.[headersType]
            }
        })

        let val = {
            module: `${tableHeaders?.[childKey]?.key}`,
            isAllData: true,
            isOnlyCurrentPage: false,
            data: {
                detailType: selectedData?.poType == "poicode" ? "item" : "set",
                orderId: selectedData?.id,
                poType: selectedData?.poType,
                setHeaderId: "",
                displayName: headerKey?.[getHeaderKey]?.key || "",
                headers: translateObjectValues(headersObject),
            },
        }

        dispatchHandler(dispatch, "downloadReportRequest", val, getPermissionKey("common", "commonfunctionality", "view"))
    }

    // Function: To upload the asn excel
    const uploadAsnExcel = (config = {}) => {
        // dispatchHandler(dispatch, "uploadMasterDataImagesRequest", formData, getPermissionKey("common", "commonfunctionality", "upload"));

        let { file } = config;
        if (file) {
            const formData = new FormData();
            formData.append("file", file)
            formData.append("orderNumber", selectedData.orderNumber)
            dispatchHandler(dispatch, "createASNUploadExcelRequest", formData, getPermissionKey("common", "commonfunctionality", "upload"));
        }
    }

    const getParentChildProps = () => {
        let payload = {
            animationType: "bottom",
            // postitionProps: { top: '50%', left: '50%', transform: 'translate(-50%, -50%)', margin: 0, position: "fixed", borderRadius: 0 },
            parentModalOuterMostClassName: 'flex items-center justify-center',
            postitionProps: { position: 'relative' },
            dimensions: { width: "100%", height: "50%" },
            closeModal: () => setOpenedModal(false),
        }
        switch (openedModal) {
            case "editBoxIdModal": {
                return {
                    ...payload,
                    dimensions: { width: "50vw", height: "65vh", maxHeight: '500px', maxWidth: '700px' },
                    box: modalData,
                    poData: selectedData,
                    closeModal: () => setOpenedModal(false),
                    closeAsnModal: props?.closeModal,
                    permissionObj: getPermissionKey("purchase", "shipment", isEdit ? "update" : "create"),
                    refreshData: () => {
                        props?.refreshAsnModal();
                    },
                    isPoNonSet: isPoNonSet,
                }
            }
            case "createBoxTemplateModal": {
                return {
                    ...payload,
                    selectedTemplate: state?.templateName || "",
                    orderNumber: selectedData?.orderNumber || "",
                    dimensions: { width: "50vw", height: "65vh", maxHeight: '500px', maxWidth: '700px' },
                    shipmentPackingType: formData?.["shipmentPackingType"]?.["shipmentPackingType"],
                    selectedBoxTemplate: getCurrentSelectedBoxTemplates(),
                    submitHandler: (item) => {
                        // Check for the box template submission
                        handleChange("boxTemplateSubmission", item);
                        let updatedFormData = { ...formData };
                        if (item?.["asn_type"]) {
                            updatedFormData = {
                                ...updatedFormData,
                                "shipmentPackingType": {
                                    "shipmentPackingType": item?.["asn_type"]
                                }
                            }
                            setFormData(updatedFormData)
                            let updatedErrorData = { ...errorData };
                            delete updatedErrorData?.["shipment_packing_type"];
                            setErrorData(updatedErrorData);
                        }
                    }
                }
            }
            case "submitMultipleAsn": {
                return {
                    ...payload,
                    animationType: "top",
                    parentModalOuterMostClassName: 'flex items-start justify-center pt-[7%]',
                    postitionProps: { position: 'relative' },
                    dimensions: { width: "45%", height: "auto", minHeight: '350px', minWidth: '400px', maxWidth: '500px', borderRadius: 5 },
                    draftedAsnData: draftedAsnData,
                    getPayload: getFinalAsnPayload,
                    isCloseBlocked: true,
                    uuId: uuId,
                    closeModalNew: () => setOpenedModal(false),
                    prevParams,
                    isSaveASNDatailEnable,
                    handleInputChange: props?.handleInputChange
                }
            }
            case 'addSkus': {
                return {
                    ...payload,
                    parentModalOuterMostClassName: 'flex items-end justify-center',
                    postitionProps: { position: 'relative' },
                    dimensions: { minHeight: '300px', height: 'fit-content', width: "100%" },
                    boxIndex: state?.addSKUModal,
                    poDetails: poDetails,
                    skuWiseBoxes: skuWiseBoxes,
                    handleSKUWiseInput: handleSKUWiseInput,
                    close: () => { toggleAddSKUModal(-1); setOpenedModal(false) },
                    discardAddSKUModal: discardAddSKUModal,
                    closeModal: () => setOpenedModal(false),
                    submit: updateRequestedQty,
                    headersData: headersData?.[getHeaderKey],
                    headersType: headersType?.[getHeaderKey],
                    isEdit: isEdit || false,
                    getRowAvailableQtyBasedOnTolerancePer,
                    getRowTolerancePerValue,
                    initalSkuWiseBoxesData: initalSkuWiseBoxesData,
                    isCloseBlocked: true,
                }
            }
            case "finalConfirmation":
            case "confirmationModal": {
                return {
                    ...payload,
                    animationType: 'bottom',
                    parentModalOuterMostClassName: 'flex items-center justify-center',
                    postitionProps: { position: 'relative' },
                    dimensions: { width: "40vw", height: "29vh", maxHeight: '270px', maxWidth: '600px' },
                    icon: () => { return <Icons.ConfirmationModalImg /> },
                    closeModal: () => { setOpenedModal(false) },
                    labelComponent: openedModal == "finalConfirmation" ? "Are you sure you want to update the ASN / Inspection ?" : 'Toggle Box Creation',
                    message: () => { return (openedModal == "finalConfirmation" ? <LanguageTranslator tag='p'>Click yes to update ASN / Inspection and No to abort.</LanguageTranslator> : <LanguageTranslator tag='p'>All the data will be reset to its original state. Are you sure you want to continue?</LanguageTranslator>) },
                    buttons: [
                        {
                            type: 'outline',
                            label: "No, wait",
                            onClick: () => { setOpenedModal(false) }
                        },
                        {
                            type: 'primary',
                            label: "Sure, Yes",
                            onClick: openedModal == "finalConfirmation" ? handleSubmit : onConfirmation
                        }
                    ]
                }
            }
            case "dicardAsnBoxesConfirmation": {
                return {
                    ...payload,
                    animationType: 'bottom',
                    parentModalOuterMostClassName: 'flex items-center justify-center',
                    postitionProps: { position: 'relative' },
                    dimensions: { width: "40vw", height: "fit-content", minHeight: '200px', maxWidth: '600px', borderRadius: 5, overflow: 'hidden' },
                    icon: () => { return <Icons.ConfirmationModalImg /> },
                    closeModal: () => { setOpenedModal(false) },
                    labelComponent: "Are you sure you want to update Shipment Packing Type ? All the current added boxes will be discarded!",
                    message: () => { return <LanguageTranslator tag='p'>Click yes to update Shipment Packing Type and No to abort.</LanguageTranslator> },
                    buttons: [
                        {
                            label: "No, wait",
                            type: 'outline',
                            onClick: () => {
                                setOpenedModal(false)
                                // Restore currentShipmentTypeData so the watcher useEffect's guard
                                // matches the reverted formData and doesn't re-open this modal.
                                setCurrentShipmentTypeData(backupShipmentTypeData);
                                let updatedFormData = { ...formData };
                                updatedFormData["shipmentPackingType"] = backupShipmentTypeData;
                                setFormData(updatedFormData);
                            }
                        },
                        {
                            label: "Sure, Yes",
                            type: 'primary',
                            onClick: () => {
                                // Remove the boxes data.
                                // setBoxes([]);
                                // setSkuWiseBoxes({});
                                setTimeout(() => {
                                    let poDetailsData = [...poDetails], skuWiseBoxesData = {};
                                    poDetailsData.forEach(item => {
                                        if (isAllQtyZero) {
                                            item.newRequestedQty = 0;
                                            item.setPendingQty = item.availableQty;
                                        }
                                        else if (!state?.boxCreation) { // Request quantity is set to available quantity when box creation is turned off
                                            item.newRequestedQty = (item?.isPoItemHold || item?.tnaCompleted === false) ? 0 : item.availableQty;
                                            item.setPendingQty = (item?.isPoItemHold || item?.tnaCompleted === false) ? item.availableQty : 0;
                                        }
                                        else { // Request quantity is set to 0 when box creation is turned on
                                            item.newRequestedQty = 0;
                                            item.setPendingQty = item.availableQty;
                                        }
                                        item.newCancelledQty = 0;
                                        item.minQtyError = "";
                                        item.maxQtyError = "";

                                        skuWiseBoxesData[item.id] = [];
                                    });
                                    setPoDetails(poDetailsData);
                                    setOriginalPoDetails(poDetailsData)
                                    setBoxes([]);
                                    setSkuWiseBoxes(skuWiseBoxesData)
                                }, 0)
                                setOpenedModal(false)
                            }
                        }
                    ]
                }
            }
            case "scanNPack": {
                return {
                    ...payload,
                    animationType: 'bottom',
                    // postitionProps: { top: '50%', left: '50%', transform: 'translate(-50%, -50%)', margin: 0, borderRadius: 4 },
                    parentModalOuterMostClassName: 'flex items-center justify-center',
                    postitionProps: { position: 'relative' },
                    dimensions: { width: "60vw", height: "60vh", maxHeight: '510px', maxWidth: '870px' },
                    headersData: headersData?.[getHeaderKey],
                    customHeader: selectedData?.poType == "poicode" ? "itemCode" : "setBarCode",
                    poDetails: poDetails,
                    submit: updateRequestedQty,
                    discardAddSKUModal: discardAddSKUModal,
                    handleSKUWiseInput: handleSKUWiseInput,
                    skuWiseBoxes: skuWiseBoxes,
                    closeScanModal: () => setOpenedModal(false),
                    addNewBox: addNewBox,
                    deleteSku: deleteSku,
                    boxPrefix: state?.boxPrefix,
                    boxes: boxes,
                    isEdit: isEdit,
                    closeModal: () => { },
                    scanTrue: !state.mixedBoxesAllowedInThisPo && !state.mixedBoxesAllowed && !state?.mixedSKUPerBox,
                    getRowAvailableQtyBasedOnTolerancePer,
                    getRowTolerancePerValue
                }
            }
            case "manageAddress": {
                return {
                    ...payload,
                    // postitionProps: {top: '50%', left: '50%', transform: 'translate(-50%, -50%)', borderRadius: 5 },
                    parentModalOuterMostClassName: 'flex items-center justify-center',
                    postitionProps: { position: 'relative' },
                    dimensions: { width: "80%", height: "70%", borderRadius: 5 },
                    permissionObj: getPermissionKey("purchase", "shipment", isEdit ? "update" : "create"),
                }
            }
            case "discardConfirmationModal": case "discardFormData": {
                return {
                    ...payload,
                    animationType: 'bottom',
                    parentModalOuterMostClassName: 'flex items-center justify-center',
                    dimensions: { minWidth: "350px", minHeight: '150px', height: "fit-content", maxWidth: '450px', maxHeight: '600px', borderRadius: 5 },
                    topExtra: () => <div className='w-full text-fontBlack px-6 py-2 bg-[#FD37571A] border-b border-[#FD375733]'>
                        <div className='flex items-start gap-3'>
                            <span><TriangleAlert size={21} color='#FD3757' /></span>
                            <div>
                                <p className='mb-0 font-semibold'><LanguageTranslator tag='span'>Warning</LanguageTranslator> !</p>
                                <LanguageTranslator tag='p' className='mb-0 text-[#FD3757] text-[13px]'>This action is irreversible.</LanguageTranslator>
                            </div>
                        </div>
                    </div>,
                    label: openedModal == "discardFormData" ? "Discard Shipment Changes" : "Discard Drafted Shipment",
                    subLabel: () => { return <LanguageTranslator tag='p'>{openedModal == "discardFormData" ? "You have unsaved changes. Are you sure you want to discard them?" : "Are you sure you want to discard the drafted shipment data? This action will permanently delete all unsaved changes and cannot be undone."}</LanguageTranslator> },
                    secondaryBtnLabel: "No, wait",
                    closeModal: () => { setOpenedModal(false) },
                    primaryBtnLabel: "Sure, Yes",
                    finalSubmit: () => closeModalV2()
                }
            }
            case "discardDraftedASN": {
                return {
                    ...payload,
                    animationType: 'bottom',
                    parentModalOuterMostClassName: 'flex items-center justify-center',
                    dimensions: { minWidth: "350px", minHeight: '150px', height: "fit-content", maxWidth: '450px', maxHeight: '600px', borderRadius: 5 },
                    topExtra: () => <div className='w-full text-fontBlack px-6 py-2 bg-[#FD37571A] border-b border-[#FD375733]'>
                        <div className='flex items-start gap-3'>
                            <span><TriangleAlert size={21} color='#FD3757' /></span>
                            <div>
                                <p className='mb-0 font-semibold'><LanguageTranslator tag='span'>Warning</LanguageTranslator> !</p>
                                <LanguageTranslator tag='p' className='mb-0 text-[#FD3757] text-[13px]'>This action is irreversible.</LanguageTranslator>
                            </div>
                        </div>
                    </div>,
                    label: "Delete Drafted ASNs?",
                    subLabel: () => { return <LanguageTranslator tag='p'>Changing the PO no. will permanently delete all drafted ASNs. Are you sure you want to proceed?</LanguageTranslator> },
                    secondaryBtnLabel: "Cancel",
                    closeModal: () => { setOpenedModal(false); setModalData(null) },
                    primaryBtnLabel: "Yes, Delete",
                    finalSubmit: () => handleChange("discardDraftedASNSubmit")
                }
            }
            case "openMediaViewModal": {
                return {
                    ...payload,
                    parentModalOuterMostClassName: 'flex items-center justify-center',
                    postitionProps: { position: 'relative' },
                    dimensions: { width: "100vw", height: "100vh", backgroundColor: 'transparent' },
                    closeModal: () => { setOpenedModal(false); setModalData({}) },
                    filesData: [
                        {
                            fileUrl: modalData?.imageUrl || "",
                            fileType: "image",
                        }
                    ]
                }
            }
            case "uploadAsnExcel": {
                return {
                    ...payload,
                    dimensions: { width: "70%", height: "80%", maxHeight: '1000px', maxWidth: '1300px', borderRadius: '5px' },
                    heading: "Upload ASN Excel",
                    filesSupprotedHeading: "XLS, XLSX",
                    filesSupportedValidationArray: ["xls", "xlsx"],
                    downloadSampleCustomFunction: () => {
                        exportExcelForThisPo()
                    },
                    submitFile: (config) => {
                        uploadAsnExcel(config);
                    },
                    finalSubmitButtonLoading : uploadMasterDataImagesData?.isLoading,
                    downloadSampleButtonLoading : downloadReportData?.isLoading,
                }
            }
        }
    }

    const getChildComponent = () => {
        switch (openedModal) {
            case "addSkus": return AddSku;
            case "finalConfirmation":
            case "confirmationModal": return GenericConfirmationModal;
            case "scanNPack": return ScanNPackModal;
            case "manageAddress": return ManageAddress;
            case "submitMultipleAsn": return MultipleAsnSubmissionModal;
            case "discardConfirmationModal": case "discardFormData": case "discardDraftedASN": return GenericDeleteModal;
            case "dicardAsnBoxesConfirmation": return GenericConfirmationModal;
            case "openMediaViewModal": return GenericMediaViewModal;
            case "createBoxTemplateModal": return CreateBoxTemplateDropdown
            case "editBoxIdModal": return EditBoxIdModal;
            case "uploadAsnExcel": return FileUpload;
            default: return <React.Fragment />
        }
    }

    const [callCreateBoxesAfterAdd, setCallCreateBoxesAfterAdd] = useState(false)

    useEffect(() => {
        if (callCreateBoxesAfterAdd) {
            createBoxes();
            setCallCreateBoxesAfterAdd(false);
        }
    }, [callCreateBoxesAfterAdd]);

    const getPoType = selectedData?.poType === "poicode" ? 'item' : 'set';
    const getHeaderKey = selectedData?.poType === "poicode" ? 'itemInner' : 'setInner';

    const toggleViewSKU = (e) => {
        const index = e.target.dataset.index;
        let boxesData = JSON.parse(JSON.stringify(boxes));
        boxesData[index].viewSKU = !boxesData[index].viewSKU;
        setBoxes(boxesData);
    }

    const getTotalCount = () => {
        let totalCount = 0;
        let totalBoxes = 0;
        boxes?.map((item, index) => {
            let noOfSKU = 0, perBoxQty = 0;
            Object.values(skuWiseBoxes).forEach(value => {
                if (value[index] && value[index] !== null) {
                    noOfSKU++;
                    perBoxQty += Number(value[index])
                }
            });
            totalCount += perBoxQty * item.boxCount
            totalBoxes += +item.boxCount;
        })
        return { totalCount, totalBoxes };
    }

    const { totalCount, totalBoxes } = getTotalCount();

    // Function : To check if the box template is selected or not 
    const isBoxTemplateSelectedOrNot = () => {
        if (state?.["boxCreation"] && boxes?.[0]?.boxTemplate?.id) {
            return true;
        }
        return false;
    }

    // function : to get the box template data which is already selected
    const getCurrentSelectedBoxTemplates = (data = boxes) => {
        let boxTemplates = {};
        if (data?.[0]?.boxTemplate) {
            data?.map((box, index) => {
                boxTemplates[box?.boxTemplate.box_id] = {
                    boxIndex: index,
                }
            })
        }
        return boxTemplates;
    }

    // function : to show the error using a custom toast
    const showError = (errorMessage) => {
        customToast({
            title: "An Error Occured!",
            description: errorMessage || `Something went wrong, please retry!`,
            status: "error",
        })
    }

    const handleChange = (seletedModal, boxCount = 1) => {
        switch (seletedModal) {
            case "addSkus": {
                let skuWiseBoxesData = JSON.parse(JSON.stringify(skuWiseBoxes)), boxesData = JSON.parse(JSON.stringify(boxes));

                Object.values(skuWiseBoxesData).forEach((item, index) => {
                    if(!isEdit){
                        if(poDetails?.[index]?.isPoItemHold || poDetails?.[index]?.tnaCompleted===false){
                            item.push(null);
                        }else{
                            item.push(!isAllQtyZero ? poDetails?.[index]?.setPendingQty : null);
                        }
                    }
                    else item.push(null)
                });

                boxesData.push({
                    id: boxesData?.length + 1,
                    boxCount: boxCount,
                    boxWeight: 0,
                    prev_box_count: 0,
                    viewSKU: false,
                });
                setSkuWiseBoxes(skuWiseBoxesData);
                setBoxes(boxesData);
                setState({
                    ...state,
                    addSKUModal: boxesData.length - 1
                });
                setOpenedModal(seletedModal)
                setCallCreateBoxesAfterAdd(true);
            }
                break;
            case "scanNPack": {
                let skuWiseBoxesData = JSON.parse(JSON.stringify(skuWiseBoxes)), boxesData = JSON.parse(JSON.stringify(boxes)), boxCount = 1;
                Object.values(skuWiseBoxesData).forEach(item => {
                    item.push(null);
                });
                boxesData.push({
                    id: ++boxIDCount,
                    boxCount: boxCount,
                    prev_box_count: 0,
                    boxWeight: 0,
                    viewSKU: false
                });
                setSkuWiseBoxes(skuWiseBoxesData);
                setBoxes(boxesData);
                setOpenedModal(seletedModal);
            }
                break;
            case "udfString01": {
                let poDetailsData = [...poDetails]
                poDetailsData[boxCount.index]["udfString01"] = boxCount?.data?.udfString01
                setPoDetails(poDetailsData)
                setOriginalPoDetails(poDetailsData)
            }
                break;
            case "setAllQtyZero": {
                setPoDetails((prevDetails) =>
                    prevDetails.map((item) => ({
                        ...item, // Preserve other properties
                        newRequestedQty: (item?.isPoItemHold || item?.tnaCompleted===false) ? 0 : (isAllQtyZero ? item.availableQty : 0),
                        setPendingQty: (item?.isPoItemHold || item?.tnaCompleted===false)? item.availableQty : (isAllQtyZero ? 0 : item.availableQty),
                        minQtyError: "",
                        maxQtyError: "",
                    }))
                );
                setOriginalPoDetails((prevDetails) =>
                    prevDetails.map((item) => ({
                        ...item, // Preserve other properties
                        newRequestedQty: (item?.isPoItemHold || item?.tnaCompleted===false) ? 0 : (isAllQtyZero ? item.availableQty : 0),
                        setPendingQty: (item?.isPoItemHold || item?.tnaCompleted===false)? item.availableQty : (isAllQtyZero ? 0 : item.availableQty),
                        minQtyError: "",
                        maxQtyError: "",
                    }))
                )
                setIsAllQtyZero(!isAllQtyZero);
                break;
            }
            case "updateQtyZero":{
                setIsAllQtyZero(!isAllQtyZero);
                break;
            }
            case "openMediaViewModal": {
                setOpenedModal(seletedModal);
                setModalData(boxCount);
                break;
            }
            case "boxTemplateSubmission": {

                try {
                    let skuWiseTemplateData = JSON.parse(JSON.stringify(boxCount?.sku_qty_json));
                    const getTotalQty = (sku) => {
                        return sku?.qty * templateBoxCount
                    }

                    // Now we have to create boxes an we have to create the sku wise boxes data;
                    let poDetailsData = [...poDetails], skuWiseBoxesData = JSON.parse(JSON.stringify(skuWiseBoxes)), templateBoxCount = boxCount?.box_count || 1;

                    // make all the quantities for the sku wise boxes data as 0
                    if (!boxes?.[0]?.boxTemplate) {
                        Object.keys(skuWiseBoxesData || {})?.map(key => {
                            if (skuWiseBoxesData?.[key]) {
                                skuWiseBoxesData?.[key]?.forEach((val, i) => {
                                    skuWiseBoxesData[key][i] = null;
                                })
                            }
                        })
                    }

                    poDetailsData.forEach(item => {
                        // let find sku first
                        let sku = skuWiseTemplateData?.find(v => v?.sku == item.id);
                        if (sku) {
                            // Check : For the request quantity and the box count multiplication should not be greater than the available qty
                            if ((getTotalQty(sku)) <= item.availableQty) {
                                if (state?.boxCreation) { // Request quantity is set to 0 when box creation is turned on
                                    if (boxes?.[0]?.boxTemplate) {
                                        item.newRequestedQty += getTotalQty(sku);
                                        item.setPendingQty = item.setPendingQty - getTotalQty(sku);
                                    } else {
                                        item.newRequestedQty = getTotalQty(sku);
                                        item.setPendingQty = item.availableQty - getTotalQty(sku);
                                    }
                                }
                                item.newCancelledQty = 0;
                                item.minQtyError = "";
                                item.maxQtyError = "";

                                // if (!skuWiseBoxesData[item.id]) {
                                //     skuWiseBoxesData[item.id] = [];
                                // }
                            } else {
                                throw new Error("Request quantity not available to select this box template!");
                            }
                        }
                    });

                    let updatedBoxes = boxes?.[0]?.boxTemplate ? JSON.parse(JSON.stringify(boxes || [])) : [];

                    // Update the boxes data based on the template data 
                    // The index for the updated box as the box that has been created new
                    let updatedBoxIndex = updatedBoxes?.length;
                    skuWiseTemplateData?.map((item, index) => {
                        if (!skuWiseBoxesData[item?.sku]) skuWiseBoxesData[item?.sku] = [];
                        skuWiseBoxesData[item?.sku][updatedBoxIndex] = Number(skuWiseBoxesData[item?.sku][updatedBoxIndex] || "") + item?.qty;
                    })
                    updatedBoxes.push({
                        id: updatedBoxIndex,
                        boxWeight: 0,
                        boxCount: templateBoxCount,
                        viewSKU: false,
                        prev_box_count: 0,
                        boxTemplate: boxCount,
                    })
                    Object.keys(skuWiseBoxesData)?.forEach(key => {
                        updatedBoxes?.map((b, index) => {
                            if (!skuWiseBoxesData[key][index])
                                skuWiseBoxesData[key][index] = null;
                        })
                    })


                    setOpenedModal(false);
                    setBoxes(updatedBoxes || []);
                    setSkuWiseBoxes(skuWiseBoxesData);
                    setPoDetails(poDetailsData);
                    setOriginalPoDetails(poDetailsData)
                    setFormData({
                        ...formData,
                        invoiceAmount: vendConfig?.VALIDATE_INV_AND_ASN_AMT?.toLowerCase() === "auto" ? 0 : formData?.invoiceAmount,
                        invoiceQuantity: vendConfig?.VALIDATE_INV_AND_ASN_AMT?.toLowerCase() === "auto" ? 0 : formData?.invoiceQuantity
                    });
                } catch (error) {
                    showError(error?.message)
                }

                break;
            }
            case "editBoxId": {
                setModalData(boxCount);
                setOpenedModal("editBoxIdModal");
                break;
            }
            case "discardDraftedASN": {
                if(Object.keys(draftedAsnData || {})?.length > 0) {
                    setOpenedModal(seletedModal);
                    setModalData([boxCount]);
                }
                else {
                    // props?.refreshAsnModal();
                    props?.handleInputChange("createAsnInspectionFromAsn", [boxCount]);
                }
                break;
            }
            case "discardDraftedASNSubmit": {
                // props?.refreshAsnModal();
                props?.handleInputChange("createAsnInspectionFromAsn", modalData)
            }
            default: {
                setOpenedModal(seletedModal);
                break;
            }
        }
    };

    const onConfirmation = () => {
        let poDetailsData = [...originalPoDetails], skuWiseBoxesData = {};
        poDetailsData.forEach(item => {
            if (state?.boxCreation) { // Request quantity is set to available quantity when box creation is turned off
                item.newRequestedQty = (item?.isPoItemHold || item?.tnaCompleted===false)? 0 : item.availableQty;
                item.setPendingQty = (item?.isPoItemHold || item?.tnaCompleted===false)? item.availableQty : 0;
            }
            else { // Request quantity is set to 0 when box creation is turned on
                item.newRequestedQty = 0;
                item.setPendingQty = item.availableQty;
            }
            item.newCancelledQty = 0;
            item.minQtyError = "";
            item.maxQtyError = "";

            skuWiseBoxesData[item.id] = [];
        });
        setOpenedModal(false);
        handleTabChange(state?.boxCreation ? 'lineItemDetails' : 'createBox');
        // setCurrentTab(state?.boxCreation ? 'lineItemDetails' : 'createBox');
        setState({
            ...state,
            boxCreation: !state?.boxCreation
        });
        setBoxes([]);
        setSkuWiseBoxes(skuWiseBoxesData);
        setPoDetails(poDetailsData);
        setOriginalPoDetails(poDetailsData)
        setFormData({
            ...formData,
            invoiceAmount: vendConfig?.VALIDATE_INV_AND_ASN_AMT?.toLowerCase() === "auto" ? 0 : formData?.invoiceAmount,
            invoiceQuantity: vendConfig?.VALIDATE_INV_AND_ASN_AMT?.toLowerCase() === "auto" ? 0 : formData?.invoiceQuantity
        });
    }

    // Function : To Upload the excel and render the asn data
    const renderUploadExcelOptionForExcel = () => {

        // This option will only be enable in case of asn using line item
        if (!state.boxCreation && !isEdit)
            return (
                <GenericCustomButton
                    label="Upload ASN Excel"
                    type='default'
                    onClick={() => handleChange("uploadAsnExcel")}
                    className='mr-[12px]'
                />
            )
    }

    const formBottomExtras = () => {
        return (
            <div className='cam-bottom-section'>
                <div className='cambs-top'>
                    <div className='cambt-left'>
                        <GenericTabsComponent
                            tabsData={{
                                lineItemDetails: "Line Item Details",
                                createBox: "Create Box"
                            }}
                            disabledTab={{
                                createBox: !state?.boxCreation
                            }}
                            current={currentTab}
                            handleTabChange={handleTabChange}
                        />
                        {boxes?.length !== 0 && <div className="summary-tabs"><span className="stbtn-box">{`${totalBoxes ? totalBoxes : 0} box${totalBoxes && totalBoxes.length > 1 ? "es" : ""} added`}</span> <span className="stbtn-box___">{`Total Quantity ${totalCount ? totalCount : 0}`}</span></div>}
                    </div>
                    {/* Render the box template */}
                    <div className='cambst-right'>

                        {/* Render the upload excel option  */}
                        {renderUploadExcelOptionForExcel()}

                        {
                            state?.boxCreation && poDetailsResponse?.boxTemplateConfig && !isEdit && <GenericCustomButton
                                // type="default"
                                style={{ marginRight: '10px' }}
                                label={"Choose Box Template"}
                                onClick={() => {
                                    setOpenedModal("createBoxTemplateModal");
                                }}
                                className={'flex items-center gap-1.5 h-[32px] text-[11px] font-medium bg-primary_w_less_opacity rounded-[3px] text-fontBlack px-3 hover:opacity-75'}
                            />
                        }

                        <LanguageTranslator tag='label' className='cambst-create-text'>Create Boxes</LanguageTranslator>
                        <div className='cambstr-toggle'>
                            <Switch disabled={isEdit || vendConfig?.ENABLE_BOX_GENERATION?.toLowerCase() === "mandatory" || vendConfig?.ENABLE_BOX_GENERATION?.toLowerCase() === "disable"} style={{ width: 45, backgroundColor: state?.boxCreation ? bootConfig?.additionalConfig?.color : "#00000040" }} checked={state?.boxCreation} onChange={() => handleChange("confirmationModal")} />
                            {isEdit ? <LanguageTranslator tag='span' className='generic-tooltip'>Cannot toggle while editing</LanguageTranslator> :
                                vendConfig?.ENABLE_BOX_GENERATION?.toLowerCase() === "disable" ? <LanguageTranslator tag='span' className='generic-tooltip'>Box creation not allowed</LanguageTranslator> :
                                    vendConfig?.ENABLE_BOX_GENERATION?.toLowerCase() === "mandatory" ? <LanguageTranslator tag='span' className='generic-tooltip'>Box creation is mandatory</LanguageTranslator> :
                                        null}
                        </div>
                    </div>
                </div>
                {currentTab == "lineItemDetails" ?
                    <LineItemDetailsTab
                        expandedSetRow={expandedSetRow} state={state} poDetailsSearchValue={poDetailsSearchValue} setPoDetailsSearchValue={setPoDetailsSearchValue}
                        selectedData={selectedData} headersData={headersData} headersType={headersType} getPoType={getPoType} isEdit={isEdit} digiVendStore={digiVendStore} anyPoOnHold={anyPoOnHold}
                        poDetails={poDetails} vendConfig={vendConfig} handleQtyInput={handleQtyInput} handleCheckInvoiceQtyBottom={handleCheckInvoiceQtyBottom} small={small} handleExpand={handleExpand}
                        itemRowData={itemRowData} getInputProps={getInputProps} handleChange={handleChange} formData={formData} tokenData={tokenData} isAllQtyZero={isAllQtyZero} getHeaderKey={getHeaderKey} checkEligibleASN={checkEligibleASN} handleEligbleASN={handleEligbleASN}
                    /> :
                    <CreateBoxTab selectedData={selectedData} uploadExcel={uploadExcel} isEdit={isEdit} boxes={boxes} skuWiseBoxes={skuWiseBoxes} handleChange={handleChange} setState={setState} createBoxes={createBoxes} state={state} deleteBox={deleteBox} openSkuModal={openSkuModal} headersData={headersData}
                        getPoType={getPoType} headersType={headersType} handleQtyInput={handleQtyInput} toggleViewSKU={toggleViewSKU} totalBoxes={totalBoxes} totalCount={totalCount} poDetails={poDetails} getHeaderKey={getHeaderKey}
                        isBoxTemplateSelectedOrNot={isBoxTemplateSelectedOrNot}
                        editresponse = {editresponse}
                        isAllQtyZero =  {isAllQtyZero}
                        setIsAllQtyZero = {setIsAllQtyZero}
                    />
                }
            </div>
        )
    }

    const checkInvoiceAmountRange = () => {
        let resultedCheckedAsnAmount = +checkAsnAmount(poDetails);
        let inVoiceAmountRangeTolerance = 0;
        if (vendConfig?.INV_AMT_TOLERANCE_TYPE?.toLowerCase() === "percentage") {
            inVoiceAmountRangeTolerance = (resultedCheckedAsnAmount * Number(vendConfig?.INV_AMT_TOLERANCE_AT_CREATE_ASN)) / 100;
        } else {
            inVoiceAmountRangeTolerance = Number(vendConfig?.INV_AMT_TOLERANCE_AT_CREATE_ASN);
        }
        let upperLimit = Number(vendConfig?.INV_AMT_TOLERANCE_AT_CREATE_ASN) && (resultedCheckedAsnAmount + inVoiceAmountRangeTolerance).toFixed(2);
        let lowerLimit = Number(vendConfig?.INV_AMT_TOLERANCE_AT_CREATE_ASN) && (resultedCheckedAsnAmount - inVoiceAmountRangeTolerance).toFixed(2);
        upperLimit = +upperLimit;
        lowerLimit = +lowerLimit;
        let invoiceAmount = +formData?.invoiceAmount;
        if (upperLimit < 0 || lowerLimit < 0 || (lowerLimit > invoiceAmount || invoiceAmount > upperLimit)) {
            customToast({
                title: "An Error Occured!",
                description: `Please Check Invoice Amount`,
                status: "error",
            })
            return false;
        }
        return true;
    }

    // Function : To check if the total requested qty of the asn is 0
    const checkZeroQtyValidation = () => {
        let totalRequestedQty = 0
        poDetails.map((item) => {
            totalRequestedQty += (item.newRequestedQty)
        });

        if (!(totalRequestedQty > 0)) {
            customToast({
                title: "An Error Occured!",
                description: `The total sum of requested qty should be greater than 0.`,
                status: "error",
            })
        }
        return totalRequestedQty > 0 ? true : false;
    }

    const checkAsnAmountValidation = () => {
        if (vendConfig?.INVOICE_UPLOAD_AT_CREATE_ASN?.toLowerCase() === "true" && vendConfig?.VALIDATE_INV_AND_ASN_AMT?.toLowerCase() === "restrict") {
            if (vendConfig?.INV_AMT_TOLERANCE_TYPE?.toLowerCase() !== "disable" && Number(vendConfig?.INV_AMT_TOLERANCE_AT_CREATE_ASN) > 0) {
                return checkInvoiceAmountRange();
            }
            else if (Number(formData?.invoiceAmount) != checkAsnAmount(poDetails)) {
                customToast({
                    title: "An Error Occured!",
                    description: `Please Check Invoice Amount`,
                    status: "error",
                })
                return false
            }
            else return true
        }
        else return true;
    }

    const checkBoxQtyValidation = () => {

        if (state?.boxCreation) {
            let totalRequestedQty = poDetails.reduce((n, { newRequestedQty }) => n + Number(newRequestedQty || ""), 0);

            let totalBoxQty = 0;
            // Check for the total of the box quantity
            boxes?.map((item, index) => {
                let perBoxQty = 0;
                Object.values(skuWiseBoxes).forEach(value => {
                    if (value[index] !== null) {
                        perBoxQty += Number(value[index])
                    }
                });
                totalBoxQty += perBoxQty * item.boxCount
            })
            if (totalBoxQty != totalRequestedQty) {
                customToast({
                    title: "Box quantity validation error!",
                    description: `Boxes Quantity Sum i.e ${totalBoxQty} is not equal to Requested Quantity i.e ${totalRequestedQty}`,
                    status: "error",
                })
                return false
            }
        }
        return true;
    }

    const checkInvoiceQtyValidation = (type = "validation") => {
        if (vendConfig?.INVOICE_UPLOAD_AT_CREATE_ASN?.toLowerCase() === "true" && vendConfig?.VALIDATE_INV_AND_ASN_AMT?.toLowerCase() === "restrict") {
            let totalRequestedQty = poDetails.reduce((n, { newRequestedQty }) => n + Number(newRequestedQty), 0);

            let totalBoxQty = 0;
            // Check for the total of the box quantity
            boxes?.map((item, index) => {
                let perBoxQty = 0;
                Object.values(skuWiseBoxes).forEach(value => {
                    if (value[index] !== null) {
                        perBoxQty += Number(value[index])
                    }
                });
                totalBoxQty += perBoxQty * item.boxCount
            })
            if (Number(formData?.invoiceQuantity) != poDetails.reduce((n, { newRequestedQty }) => n + Number(newRequestedQty), 0)) {

                customToast({
                    title: "Invoice quantity validation error!",
                    description: `Invoice Quantity is not equal i.e ${totalRequestedQty} to Requested Quantity`,
                    status: "error",
                })
                return false
            }
            else return true
        }
        else return true
    }

    const boxsQtyError = () => {
        let result = boxes.map((item, index) => {
            let perBoxQty = 0;
            Object.values(skuWiseBoxes).forEach(value => {
                if (value[index] !== null) {
                    perBoxQty += Number(value[index])
                }
            });
            return perBoxQty
        });
        return result.some(item => item <= 0);
    }

    const checkBoxCreationError = () => {
        if (state?.boxCreation) {
            if (boxes?.length === 0) {
                customToast({
                    title: "An Error Occured!",
                    description: `Please Add Boxes`,
                    status: "error",
                })
                return false
            }
            else if (boxes?.some(item => item.boxWeight == 0)) {
                customToast({
                    title: "An Error Occured!",
                    description: `Please Check Boxes Weight`,
                    status: "error",
                })
                return false
            }
            else if (isEdit && boxes?.some(item => item?.boxCount == 0)) {
                customToast({
                    title: "An Error Occured!",
                    description: `Please Check Boxes Qty`,
                    status: "error",
                })
                return false
            }
            else if (boxsQtyError()) {
                customToast({
                    title: "An Error Occured!",
                    description: `Please Check Boxes Qty`,
                    status: "error",
                })
                return false
            }
            else return true
        }
        else return true
    }

    const checkRemainingChecks = () => {
        let newIndex = poDetails.findIndex(item => item.minQtyError !== "" || item.maxQtyError !== "")
        let boxCountErrorIndex = boxes?.findIndex(item => item?.boxCountError);

        if (newIndex != -1) {
            customToast({
                title: "An Error Occured!",
                description: `Please Check Qty Error`,
                status: "error",
            })

            setCurrentTab("lineItemDetails")
            setTimeout(() => {
                scrollIntoViewIfNeeded(document.getElementById(`asnLineRow${newIndex}`));
            }, 100)
            return false
        }
        else if (boxCountErrorIndex != -1) {
            customToast({
                title: "An Error Occured!",
                description: `Please check box quantities.`,
                status: "error",
            })

            setCurrentTab("createBox")
            setTimeout(() => {
                scrollIntoViewIfNeeded(document.getElementById(`boxLineRow${newIndex}`));
            }, 100)
            return false
        }
        else return true
    }

    // Function to check if LBH and Weight are mandatory for a given item
    const isLBHWeightMandatory = (item, weightMandatory, lbhMandatory) => {
        const { newRequestedQty, length, breadth, height, weight } = item;

        if (!newRequestedQty || +(newRequestedQty) === 0) {
            return false;
        }

        if (weightMandatory === "Mandatory" && (weight === undefined || weight === null || weight === "")) {
            return true;
        }

        if (lbhMandatory === "Mandatory" && (!length || !breadth || !height)) {
            return true;
        }

        return false;
    };

    const isDraftCreationInAsnAllowed = () => {
        if (isEdit) {
            return false;
        }
        else if (vendConfig?.ASN_CREATION_STRATEGY && vendConfig?.ASN_CREATION_STRATEGY?.toUpperCase() == "MULTIPLE") {
            return true
        }
        return false;
    }

    const getNextKey = (key) => {
        let index = key?.split('-');
        index = index?.[1];
        return Number(index) + 1;
    }

    const getNextKeyForDraft = () => {
        return draftAsnMaxKey;
    }

    const getCurrentKeyForRequestId = () => {
        return currentDraftAsnIndex === -1 ? getNextKeyForDraft() : `Draft-${currentDraftAsnIndex}`;
    }

    const saveDraftAndCreateNew = () => {

        let data = JSON.parse(JSON.stringify(poDetailsResponse));

        let updatedDraftedAsn = { ...draftedAsnData };

        if (handleSubmit("checkDraftSubmission")) {

            let key = currentDraftAsnIndex === -1 ? getNextKeyForDraft() : `Draft-${currentDraftAsnIndex}`;

            updatedDraftedAsn[key] = {
                "formData": formData,
                "currentTab": currentTab,
                "state": state,
                "skuWiseBoxes": skuWiseBoxes,
                "boxes": boxes,
                "poDetails": poDetails,
                "uuId": uuId,
            }

            setDraftedAsnData(updatedDraftedAsn);
            if (currentDraftAsnIndex === -1) {
                setDraftAsnMaxKey(`Draft-${getNextKey(draftAsnMaxKey)}`)
            }
            const hasContactNo = !!formData?.contactNo;
            setFormData({});
            setErrorData({})
            // Reset late delivery charge acceptance so each new draft requires fresh acceptance
            setLateDeliveryChargeAccepted(false);
            setIsAllQtyZero(vendConfig?.ZERO_QTY_ASN_FORM_INITIALISATION || true ? true : false);
            data = getTotalDraftedAsnQty(updatedDraftedAsn, data)?.data


            updateStateForCreateForm(data, "normal", { contactNo: hasContactNo ? "+91" : undefined });

            setResetDataForDraftAsn(true);


        }

    }

    const openAsnDropdown = (e) => {
        e.stopPropagation()
        setShowDraftedAsnDropdown(!showDraftedAsnDropdown);
        setTimeout(() => document.addEventListener('click', () => closeAsnDropdown(e)), 0)
    }

    const closeAsnDropdown = (e) => {
        let modal = document.getElementById("draftedAsnDropdown");
        if (!modal?.contains(e?.target)) {
            setShowDraftedAsnDropdown(false);
            document.removeEventListener('click', closeAsnDropdown)
        }
    }

    const isNewMethodAllowed = () => {
        const disallowedIDs = ["64", "3152"];
        const id = tokenData?.schemaEntID?.toString();
        if(prevParams?.type === "CREATE_SHIPMENT") {
            return true
        }
        return !(vendConfig?.OLD_ASN_CREATE_API?.toLowerCase?.() === "true")
        // return !disallowedIDs.includes(id) ;
    }

    const handleSubmit = (trigger, data) => {

        if (isDraftCreationInAsnAllowed() && trigger != "checkDraftSubmission") {
            if(data?.type == "saveAndContinueWithLr") {
                setisSaveASNDatailEnable(true);
            }
            setOpenedModal("submitMultipleAsn");
        } else {
            // Main logic simplified using the isLBHWeightMandatory function
            const checkMandateLBWH = poDetails?.map(item => isLBHWeightMandatory(item, state?.weightMandatory, state?.lbhMandatory));
            let LBHWeightDisable = true;
            if (!isEdit) {
                checkMandateLBWH.forEach((isMandatory, index) => {
                    if (isMandatory && (poDetails?.[index]?.newRequestedQty !== "" || poDetails?.[index]?.newRequestedQty !== undefined || poDetails?.[index]?.newRequestedQty !== null || +(poDetails?.[index]?.newRequestedQty) !== 0)) {
                        LBHWeightDisable = false;
                    }
                });
            }

            if (LBHWeightDisable === false) {
                customToast({
                    title: "An Error Occured!",
                    description: `Please Check Line Item Details and fill All the Mandatory Details.`,
                    status: "error",
                })
            }

            if (finalSubmitValidationsCheck() && checkAsnAmountValidation() && checkInvoiceQtyValidation() && checkBoxQtyValidation?.() && checkBoxCreationError() && checkRemainingChecks() && LBHWeightDisable && checkZeroQtyValidation?.()) {

                let payload = getFinalAsnPayload({
                    poDetails,
                    formData,
                    state,
                    boxes,
                    skuWiseBoxes,
                })

                if (isEdit && trigger == "button") {
                    setOpenedModal("finalConfirmation");
                } else if (trigger == "checkDraftSubmission") {
                    return true;
                } else {
                    // Check for the hopscotch -> if the vendor or retailer is from hopscotch call the newer version of the api.
                    if(prevParams?.type === "CREATE_SHIPMENT_WITH_LR" && data?.type == "saveAndContinueWithLr") {
                        props?.handleInputChange?.("storeASNData", [{ ...payload, requestId: `${uuId}-Draft1` }]);
                    }
                    else if (!isEdit && isNewMethodAllowed()) {
                        payload = [
                            { ...payload, requestId: `${uuId}-Draft1` }
                        ]
                        dispatchHandler(dispatch, "createMultipleAsnRequest", payload, getPermissionKey("purchase", "shipment", isEdit ? "update" : "create"))
                    } else {
                        dispatchHandler(dispatch, "vendorshipCreateSrNewRequest", payload, getPermissionKey("purchase", "shipment", isEdit ? "update" : "create"))
                    }
                    setOpenedModal(false)
                }
            }
        }
    }

    const uploadExcel = (e) => {
        let fileName = e?.target?.files?.[0]?.name;
        let extension = fileName?.substring(fileName?.lastIndexOf("."))?.toLowerCase();
        if (![".xlsx", ".xls", ".csv"]?.includes(extension)) {
            customToast({
                title: "An Error Occured!",
                description: `Invalid file selected! Only .xlsx, .xls, .csv are allowed.`,
                status: "error",
            })
        }
        else if (e?.target?.files?.[0]?.size > 20 * 1024 * 1024) { // 20MB
            customToast({
                title: "An Error Occured!",
                description: `File size too large! Maximum 20MB is allowed.`,
                status: "error",
            })
        }
        else {
            readXlsxFile(e.target.files[0]).then((rows) => {
                // Remove the header row
                rows.splice(0, 1);
                rows.sort((a, b) => a[0] - b[0]);

                let boxIndex = 0;
                for (let i = 0; i < rows.length; i++) {
                    handleChange("addSkus", Number(rows[i][3]) || 1); // rows[i][3] = Number of boxes
                    do {
                        handleSKUWiseInput({
                            target: {
                                _excelIndex: boxIndex,
                                value: rows[i][2], // rows[i][2] = Request Qty
                                dataset: {
                                    sku: rows[i][1], // rows[i][1] = SKU
                                },
                            },
                        });
                        i++;
                    } while (rows[i] && rows[i][0] === rows[i - 1][0]);
                    boxIndex++;
                    i--;
                }
                setCallAfterExcelUpload(true);
            });
        }
    }

    const deleteImgFromServer = (files) => {
        let payload = [];
        files?.map((file) => {
            let fileObj = {
                fileName: file?.fileName,
                filePath: file?.filePath,
                id: file?.id
            }
            payload.push(fileObj);
        });
        dispatchHandler(dispatch, "utilityDocumentDeleteRequest", payload, getPermissionKey("purchase", "shipment", isEdit ? "update" : "create"));
    }

    const getTotalDraftedAsnQty = (updatedDraftedAsn, data) => {
        // Update the po details request qty here
        let totalDraftRequestedQty = [];
        let totalDraftCancelledQty = [];

        Object.values(updatedDraftedAsn || {})?.map(item => {
            item?.poDetails?.map((po, index) => {
                totalDraftRequestedQty[index] = (totalDraftRequestedQty[index] ?? 0) + Number(po.newRequestedQty);
                totalDraftCancelledQty[index] = (totalDraftCancelledQty[index] ?? 0) + Number(po.newCancelledQty);
            })
        })

        data.poDetails = data.poDetails?.map((item, index) => ({
            ...item,
            availableQty: Number(item.availableQty || "") - Number(totalDraftRequestedQty[index] || "") - Number(totalDraftCancelledQty[index] || ""),
            // Keep the already-requested counters (used by the tolerance calculation in
            // getRowAvailableQtyBasedOnTolerancePer) in sync with the qty consumed by drafts, so the
            // tolerance headroom is shared across multiple ASNs instead of being granted afresh each time.
            totalRequestedQty: Number(item.totalRequestedQty || 0) + Number(totalDraftRequestedQty[index] || 0) + Number(totalDraftCancelledQty[index] || 0),
            setRequestedQty: Number(item.setRequestedQty || 0) + Number(totalDraftRequestedQty[index] || 0) + Number(totalDraftCancelledQty[index] || 0),
            newRequestedQty: Math.max(0, Number(item.newRequestedQty || 0) - Number(totalDraftRequestedQty[index] || 0) - Number(totalDraftCancelledQty[index] || 0)),
            length: "",
            weight: "",
            height: "",
            breadth: "",
        }))

        return {
            data,
            totalDraftRequestedQty,
            totalDraftCancelledQty,
        };

    }

    const handleDraftActions = (type, data) => {
        switch (type) {
            case "deleteDraftAsn": {
                let removedItem = draftedAsnData?.[`${data}`];

                let updatedPoDetails = [...poDetails];
                updatedPoDetails = updatedPoDetails?.map((item, index) => ({
                    ...item,
                    "setPendingQty": Number(item?.setPendingQty || 0) + Number(removedItem?.poDetails?.[index]?.newRequestedQty || "") + Number(removedItem?.poDetails?.[index]?.newCancelledQty || ""),
                    "availableQty": Number(item?.availableQty || 0) + Number(removedItem?.poDetails?.[index]?.newRequestedQty || "") + Number(removedItem?.poDetails?.[index]?.newCancelledQty || ""),
                }))
                    ;
                let updatedDraftedAsn = { ...draftedAsnData };
                delete updatedDraftedAsn?.[`${data}`]

                setPoDetails(updatedPoDetails);
                setOriginalPoDetails(updatedPoDetails)
                setDraftedAsnData(updatedDraftedAsn);
                break;
            }
            case "editDraftAsn":

                let draftAsn = draftedAsnData?.[`${data}`];

                // Keep currentShipmentTypeData in sync with the draft's packing type so the
                // watcher useEffect doesn't treat this programmatic load as a user-driven change
                // and open the discard-boxes confirmation modal.
                setCurrentShipmentTypeData(draftAsn?.formData?.["shipmentPackingType"] || null);
                setFormData(draftAsn?.formData);
                setCurrentTab(draftAsn?.currentTab);
                setState(draftAsn?.state);
                setSkuWiseBoxes(draftAsn?.skuWiseBoxes);
                setBoxes(draftAsn?.boxes);
                setUuId(draftAsn?.uuId);
                setErrorData({});
                // A saved draft was already accepted, so restore acceptance when re-opening it
                setLateDeliveryChargeAccepted(Number(selectedData?.lateDeliveryCharges ?? 0) > 0);

                let updatedPoDetails = [...poDetails];
                updatedPoDetails = updatedPoDetails?.map((item, index) => ({
                    ...item,
                    "newRequestedQty": draftAsn?.poDetails?.[index]?.newRequestedQty,
                    "newCancelledQty": draftAsn?.poDetails?.[index]?.newCancelledQty,
                    "setPendingQty": (item?.availableQty || 0),
                    "availableQty": item?.availableQty + Number(draftAsn?.poDetails?.[index]?.newRequestedQty) + Number(draftAsn?.poDetails?.[index]?.newCancelledQty),
                    "length": draftAsn?.poDetails?.[index]?.length,
                    "breadth": draftAsn?.poDetails?.[index]?.breadth,
                    "height": draftAsn?.poDetails?.[index]?.height,
                    "weight": draftAsn?.poDetails?.[index]?.weight,
                }))

                setPoDetails(updatedPoDetails);
                setOriginalPoDetails(updatedPoDetails)

                setCurrentDraftAsnIndex(getNextKey(data) - 1)

                break;
            default:
                break;
        }
    }

    useEffect(() => {
        if (callAfterExcelUpload) {
            setCallAfterExcelUpload(false);
            updateRequestedQty();
            toggleAddSKUModal(-1);
        }
    }, [callAfterExcelUpload]);

    const getSummaryDetails = () => {
        // Calculate totals
        const totals = poDetails.reduce(
            (acc, item) => {
                acc.totalNewRequestedQty += Number(item.newRequestedQty)*Number(item.singleSetQty || 1) ?? 0;
                return acc;
            },
            { totalNewRequestedQty: 0 }
        );
        return totals;
    }

    const toggleHoldAsnDropdown = (e) => {
        e.stopPropagation();
        setShowHoldAsnDropdown(!showHoldAsnDropdown);

        if (!showHoldAsnDropdown) {
            const closeDropdown = () => {
                setShowHoldAsnDropdown(false);
                document.removeEventListener('click', closeDropdown);
            };
            setTimeout(() => document.addEventListener('click', closeDropdown), 0);
        }
    }
    const history = useHistory();
    const location = useLocation();

    const openDocumentViewer = (docNo) => {
        let obj = modifyDataForDocumentViewerUrlInsertion("encode", {
            documentId: docNo, 
            documentNo: docNo,
            documentType: "ASN",
        });
        setPayloadAsURLParams({
            data: {
                ...getPayloadFromURLParams({
                    l: location,
                }),
                documentViewerConfig: obj,
            },
            l: location,
            h: history,
        });
    }

    const getSummaryKeys = {
        poQuantity: "Total PO Qty",
        totalPendingQty: "Pending Qty",
        totalRequestQty: "Requested Qty",
    }

    console.log("draftedAsnData data", currentDraftAsnIndex, draftedAsnData)

    // To render the draft asn ui
    const renderDraftAsnDropdown = () => {
        return (
            <>
                {Object.keys(draftedAsnData || {})?.length > 0 && <div className='relative mr-5'>
                    {/* <div className='flex items-center gap-2 max-w-[300px]'>
                        <Icons.DocumentMediaIcon />
                        <p>You have multiple Draft ASN's that you can edit simultaneously until you submit and create the ASN document.</p>
                    </div> */}

                    <div className={`px-2.5 py-1 min-w-[170px] border border-borderSlateGrey flex items-center justify-between gap-3 cursor-pointer duration-200 hover:bg-[#F2F4F7] ${showDraftedAsnDropdown ? 'bg-[#F2F4F7]' : ''}`} onClick={(e) => openAsnDropdown(e)}>
                        <div>
                            <LanguageTranslator tag="p" className='!mb-0 !text-[11px] !text-fontGrey !font-normal'>{`Drafted ASN${Object.keys(draftedAsnData || {})?.length == 1 ? "" : 's'}`}</LanguageTranslator>
                            <LanguageTranslator tag="p" className='!mb-0 !font-semibold !text-[13px] !text-[#21314b]'>{currentDraftAsnIndex == -1 ? getNextKeyForDraft() : `Draft-${currentDraftAsnIndex}`}</LanguageTranslator>
                        </div>
                        <ChevronDown size={18} />
                    </div>

                    <div id="draftedAsnDropdown" className={`w-full absolute mt-[4px] top-full z-[4] duration-200 ${showDraftedAsnDropdown ? 'translate-y-0 opacity-100 visible pointer-events-auto' : '-translate-y-2 opacity-0 invisible pointer-events-none'}`}>
                        {showDraftedAsnDropdown && <div className='bg-white min-w-[120px] py-1 max-h-[165px] overflow-y-auto' style={{ boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px" }}>
                            <LanguageTranslator tag="p" className='!mt-[6px] !mb-[2px] !px-2.5 !text-[10px] !font-semibold !text-[#21314b]'><LanguageTranslator>Total Draft ASN</LanguageTranslator> : {Object.keys(draftedAsnData || {})?.length}</LanguageTranslator>
                            {Object.keys(draftedAsnData || {})?.map((item, index) => (
                                <div className='px-2.5 py-2 flex items-center justify-between gap-2'>
                                    <LanguageTranslator tag="p" className='mb-0 whitespace-nowrap text-[#21314b] text-xs'>{isClientHopscotch?.() 
                                            ? (draftedAsnData?.[item]?.formData?.stockRediness?.stockRediness || item) + " - " + item.split("-")?.[1] 
                                            : item}</LanguageTranslator>
                                    <div className='flex items-center gap-3'>
                                        <GenericCustomButton disabled={currentDraftAsnIndex != -1} leftIcon={<SquarePen size={17} className='text-[#707494] group-hover:text-primary' />} tooltip="Edit" className={'group'} onClick={() => { handleDraftActions("editDraftAsn", item) }} />
                                        <GenericCustomButton disabled={currentDraftAsnIndex != -1}leftIcon={<Trash2 size={17} className='text-[#707494] group-hover:text-danger' />} tooltip="Delete" className={'group'} onClick={() => { handleDraftActions("deleteDraftAsn", item) }} />
                                    </div>
                                </div>
                            ))}
                        </div>}
                    </div>
                </div>}
            </>
        )
    }
    const renderFormTopExtras = () => {

        const getIcon = {
            poQuantity: <Icons.TotalPo />,
            totalPendingQty: <Icons.RemainingQty />,
            totalRequestQty: <FileCheck size={17} strokeWidth={1.5} color='white' />,
        }

        const lateDeliveryCharge = Number(selectedData?.lateDeliveryCharges ?? 0);

        return (
            <div className='flex flex-col gap-3'>
            {lateDeliveryCharge > 0 && !isEdit && (
                <div className='mr-3.5 px-[15px] py-2.5 bg-[#FE9D0B]/10 rounded-[5px] flex items-center gap-2'>
                    <label className={`generic-checkbox !block !font-normal !pl-[16px]`}>
                        <input
                            type="checkbox"
                            checked={lateDeliveryChargeAccepted}
                            onChange={(e) => setLateDeliveryChargeAccepted(e.target.checked)}
                        />
                        <span className="checkmark1"></span>
                    </label>
                    <TriangleAlert size={17} color='#FE9D0B' strokeWidth={2.5} />
                    <LanguageTranslator tag='p' className='!mb-0 !text-[12px] !font-medium !text-fontBlack'>
                        Due to late delivery, a late delivery charge of {Number(lateDeliveryCharge)}% (as assigned by the retailer on this PO) will be applicable. Please apply ASN if you accept or get in touch with your respective buyer.
                    </LanguageTranslator>
                </div>
            )}
            <div className='extraDetails pb-3.5 pr-3.5 flex items-center justify-between gap-4'>
                <div className='flex items-center gap-4'>
                    {<>
                        <div className='px-3 py-2.5 bg-[#FAFAFA] rounded-[10px] grid grid-cols-[auto_auto] items-center gap-5'>
                            <div>
                                <div className='flex gap-2  items-start'><LanguageTranslator tag="h3" className='!mb-1.5 !text-base !font-semibold !text-fontBlack'>{getSummaryDetails?.()?.totalNewRequestedQty}</LanguageTranslator> <div className='w-[6px] h-[6px] mt-[6px] rounded-full bg-[#03B675] shadow-[0_0_6px_#03B675]'></div></div>
                                <LanguageTranslator tag="h5" className='!mb-0 !text-[11px] !font-normal !text-[#4A5D7A]'>Requesting Qty</LanguageTranslator>
                            </div>
                            <div className='h-full flex flex-col justify-end items-center'>
                                {/* <div className='p-[2px] h-[24px] w-[24px] rounded-[5px] shrink-0 flex items-center justify-center bg-[#03B675]'><Icons.TotalPo/></div> */}
                                <div className='p-[2px] h-[24px] w-[24px] rounded-[5px] shrink-0 flex items-center justify-center bg-[#ECB80B]'><ClipboardList size={17} strokeWidth={1.5} color='white' /></div>
                            </div>
                        </div>
                        <span>=</span>
                    </>}

                    {Object.keys(getSummaryKeys)?.map((key, index) =>
                        <>
                            <div className='px-3 py-2.5 bg-[#FAFAFA] rounded-[10px] grid grid-cols-[auto_auto] items-center gap-5'>
                                <div>
                                    <LanguageTranslator tag="h3" className='!mb-1.5 !text-base !font-semibold !text-fontBlack'>{key === 'totalPendingQty' ? (Number(asnSummary?.[key]) - Number(getSummaryDetails?.()?.totalNewRequestedQty)) || 0 : asnSummary?.[key] || 0}</LanguageTranslator>
                                    <LanguageTranslator tag="h5" className='!mb-0 !text-[11px] !font-normal !text-[#4A5D7A]'>{getSummaryKeys?.[key]}</LanguageTranslator>
                                </div>
                                <div className={`h-full flex flex-col ${key === 'totalRequestQty' ? 'justify-between items-center' : 'justify-end items-center'}`}>
                                    {key === 'totalRequestQty' && (
                                        <div className={`relative flex gap-1 items-center z-[20]`}>
                                            {((vendConfig?.asnMask?.toLowerCase() !== "true" && vendConfig?.LOGISTIC_ASN_MASKING?.toLowerCase() !== "true") || Number(asnSummary?.asnCount || 0) === 0) ? (
                                                <>
                                                    <Info
                                                        size={12}
                                                        className="cursor-pointer text-[#4A5D7A] hover:text-primary transition-colors"
                                                        onClick={toggleHoldAsnDropdown}
                                                    />
                                                    <span className="text-[11px] !font-normal !text-[#4A5D7A]">
                                                        ASN : {asnSummary?.asnCount || 0}
                                                    </span>
                                                </>
                                            ) : (
                                                <div className="relative group flex gap-1 items-center bg-[#FE9D0B1A] rounded-[4px] px-[5px] py-[2px] cursor-pointer">
                                                    <EyeOff size={11} color='#FE9D0B' />
                                                    <span className="text-[11px] !font-normal !text-[#4A5D7A]">
                                                        ASN : {asnSummary?.asnCount || 0}
                                                    </span>
                                                    <span className="generic-tooltip tooltip-right group-hover:opacity-100 group-hover:visible group-hover:pointer-events-auto !bg-[#FFB103] !text-white [&:after]:!border-t-[#FFB103] ">
                                                        All ASN are masked or hidden
                                                    </span>
                                                </div>
                                            )}

                                            {showHoldAsnDropdown && asnSummary?.asnNumbers && (vendConfig?.asnMask?.toLowerCase() !== "true" && vendConfig?.LOGISTIC_ASN_MASKING?.toLowerCase() !== "true") &&  (
                                                <div
                                                    className="absolute top-full left-[-8px] mt-1.5 bg-white border border-[#E2E8F0] rounded-[6px] shadow-[0_4px_12px_rgba(0,0,0,0.1)] py-1 min-w-[180px]"
                                                    onClick={(e) => e.stopPropagation()}
                                                >
                                                    <div className="absolute top-[-5px] left-[11px] w-2.5 h-2.5 bg-white border-l border-t border-[#E2E8F0] rotate-45"></div>

                                                    <div className="max-h-[160px] overflow-y-auto custom-scrollbar relative bg-white rounded-[6px]">
                                                        {asnSummary?.asnNumbers?.split('|').filter(Boolean).map((asn, i) => (
                                                            <div
                                                                key={i}
                                                                className="px-3 py-2 hover:bg-[#F3F4F6] text-[12px] text-[#334155] font-medium transition-colors cursor-pointer border-b border-[#f1f1f1] last:border-0"
                                                                onClick={(e) => {
                                                                    e.stopPropagation()
                                                                    openDocumentViewer(asn?.trim())
                                                                }}
                                                            >
                                                                {asn?.trim()}
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                    <div className={`p-[2px] h-[24px] w-[24px] rounded-[5px] shrink-0 flex items-center justify-center ${key === 'totalPendingQty' ? 'bg-[#FF793F]' : key === 'poQuantity' ? 'bg-green-500' : 'bg-[#ECB80B]'} `}>{getIcon?.[key]}</div>
                                    {/* <div className='p-[2px] h-[24px] w-[24px] rounded-[5px] shrink-0 flex items-center justify-center bg-[#5D5FEF]'><ClipboardList size={17} strokeWidth={1.5} color='white' /></div> */}
                                </div>
                            </div>
                            {index != Object.keys(getSummaryKeys)?.length - 1 && <span>-</span>}
                        </>
                    )}
                </div>
                <div>
                    {!isEdit && <div className='px-3 py-2.5 bg-[#FAFAFA] rounded-[10px] grid grid-cols-[auto_auto] items-center gap-5'>
                        <div>
                            <LanguageTranslator tag="h3" className='!mb-1.5 !text-base !font-semibold !text-fontBlack flex items-center gap-1'><span>₹</span><span>{editresponse?.poAmount || '-'}</span></LanguageTranslator>
                            <LanguageTranslator tag="h5" className='!mb-0 !text-[11px] !font-normal !text-[#4A5D7A]'>Total PO Amount</LanguageTranslator>
                        </div>
                        <div className='h-full flex flex-col justify-end items-center'>
                            <div className='p-[2px] h-[24px] w-[24px] rounded-[5px] shrink-0 flex items-center justify-center bg-[#5D5FEF]'><HandCoins size={17} strokeWidth={1.5} color='white' /></div>
                        </div>
                    </div>}
                </div>
            </div>
            </div>
        )
    }

    const checkDiscardModal = () => {
        if (Object.keys(draftedAsnData || {})?.length > 0) {
            setOpenedModal("discardConfirmationModal")
        }
        else if (Object.keys(formData || {})?.length > 4 || confirmationModalShow) {
            setOpenedModal("discardFormData")
        }
        else closeModalV2()
    }

    if(getDigicatFormSettingsData?.isLoading){
        return (
            <div className='create-asn-modal' style={{display:"flex", flexDirection:"row", justifyContent:"center", alignItems:"center"}}>
                <GenericSpinnerLoader/>
            </div>
        )
    }

    let parseToken = parseJwt(sessionStorage.getItem('token')), hopscotchSchemaEntId = ["8534", "754"];

    return (
        <div className='create-asn-modal'>
            <GenericFormComponent
                headerComponent={{
                    // label: {
                    //     contentPrimary: modalHeading
                    // },
                    label: ()=> {
                    return <div className='flex items-center gap-7'>
                        <div className='mhs-left'>
                            <h4 className='whitespace-nowrap'>{modalHeading}</h4>
                        </div>
                        <div className='mhs-left flex items-center gap-3'>
                            {!isEdit && <GenericInput
                                genInputExtraClass="!w-[220px] !m-0"
                                gibInnerClassName="!border-[#A9A8A8]" 
                                key="orderNumber"
                                value={selectedData?.orderNumber}
                                type={"dropdown"}
                                inputProps={() => getInputProps("getPoDetails")}
                                onChange={(data) => handleChange("discardDraftedASN", data)}
                                iconRight={
                                    <div className="flex items-center h-[31px] !-my-3 gap-1">
                                        {selectedData?.orderNumber && (() => {
                                            const isNonSet = selectedData?.poType === "poicode";
                                            return (
                                                <span className={`text-[11px] font-semibold leading-[1.28] px-[3.5px] rounded-[3px] border-[1.5px] ${isNonSet ? "text-[#FF793F] border-[#FF793F]" : "text-[#1B9CFC] border-[#1B9CFC]"}`}>
                                                    {isNonSet ? "N" : "S"}
                                                </span>
                                            );
                                        })()}
                                        <div className="border-l border-[#A9A8A8] flex items-center h-full pl-2 ml-1">
                                            <Icons.DownArrowNew />
                                        </div>
                                    </div>
                                }
                            />}
                            <div className='mhsl-row'>
                                {isEdit && <div className='ksmhl-col'>
                                    <LanguageTranslator tag='p'>PO Number</LanguageTranslator>
                                    <h3 className="flex items-center gap-1">
                                        {selectedData?.orderNumber || "-"}
                                        {(() => {
                                            const isNonSet = selectedData?.poType === "poicode";
                                            return (
                                                <span className={`text-[11px] font-semibold leading-[1.28] px-[3.5px] rounded-[3px] border-[1.5px] ${isNonSet ? "text-[#FF793F] border-[#FF793F]" : "text-[#1B9CFC] border-[#1B9CFC]"}`}>
                                                    {isNonSet ? "N" : "S"}
                                                </span>
                                            );
                                        })()}
                                    </h3>
                                </div>}
                                {hopscotchSchemaEntId?.includes(parseToken?.schemaEntID) && <div className='ksmhl-col'>
                                    <p>Child SOS Number</p>
                                    <h3>{selectedData?.erpShipmentNo || "-"}</h3>
                                </div>}
                                <div className='ksmhl-col'>
                                    <p><LanguageTranslator>{vendConfig?.inspectionRequired?.toLowerCase() === "true" ? "Inspection Number" : "ASN Number"}{hopscotchSchemaEntId?.includes(parseToken?.schemaEntID) ? ' ' : ''}</LanguageTranslator></p>
                                    <h3>{selectedData?.asnMask || "-"}</h3>
                                </div>
                                <div className='ksmhl-col'>
                                    <LanguageTranslator tag='p'>PO Validity</LanguageTranslator>
                                    <h3>{selectedData?.validFromDate || ""} - {selectedData?.validToDate || ""}</h3>
                                </div>
                                {vendConfig?.asnFromToApplicablility?.toLowerCase() === "true" && <div className='ksmhl-col'>
                                    <LanguageTranslator tag='p'>ASN Validity</LanguageTranslator>
                                    <h3>{selectedData?.asnFromDate || ""} - {selectedData?.asnToDate || ""}</h3>
                                </div>}
                                {selectedData?.ordRemark && <div className='ksmhl-col'>
                                    <p><LanguageTranslator>Order Remarks</LanguageTranslator></p>
                                    <h3>{selectedData?.ordRemark || "-"}</h3>
                                </div>}
                            </div>
                        </div>
                    </div>
                    },
                    // rightComponent:
                    //     () => {
                    //         let parseToken = parseJwt(sessionStorage.getItem('token')), hopscotchSchemaEntId = ["8534", "754"];

                    //         return (
                    //             <div className='mhs-left flex items-center gap-3'>
                    //                 {!isEdit && <GenericInput
                    //                     genInputExtraClass="!w-[165px] !m-0"
                    //                     key="orderNumber"
                    //                     value={selectedData?.orderNumber}
                    //                     type={"dropdown"}
                    //                     inputProps={() => getInputProps("getPoDetails")}
                    //                     onChange={(data) => handleChange("discardDraftedASN", data)}
                    //                     iconRight={<Icons.DownArrowNew />}
                    //                 />}
                    //                 <div className='mhsl-row'>
                    //                    {isEdit && <div className='ksmhl-col'>
                    //                         <LanguageTranslator tag='p'>PO Number</LanguageTranslator>
                    //                         <h3>{selectedData?.orderNumber || "-"}</h3>
                    //                     </div>}
                    //                     {hopscotchSchemaEntId?.includes(parseToken?.schemaEntID) && <div className='ksmhl-col'>
                    //                         <p>Child SOS Number</p>
                    //                         <h3>{selectedData?.erpShipmentNo || "-"}</h3>
                    //                     </div>}
                    //                     <div className='ksmhl-col'>
                    //                         <p><LanguageTranslator>{vendConfig?.inspectionRequired?.toLowerCase() === "true" ? "Inspection Number" : "ASN Number"}{hopscotchSchemaEntId?.includes(parseToken?.schemaEntID) ? ' ' : ''}</LanguageTranslator></p>
                    //                         <h3>{selectedData?.asnNo || "-"}</h3>
                    //                     </div>
                    //                     <div className='ksmhl-col'>
                    //                         <LanguageTranslator tag='p'>PO Validity</LanguageTranslator>
                    //                         <h3>{selectedData?.validFromDate || ""} - {selectedData?.validToDate || ""}</h3>
                    //                     </div>
                    //                     {vendConfig?.asnFromToApplicablility?.toLowerCase() === "true" && <div className='ksmhl-col'>
                    //                         <LanguageTranslator tag='p'>ASN Validity</LanguageTranslator>
                    //                         <h3>{selectedData?.asnFromDate || ""} - {selectedData?.asnToDate || ""}</h3>
                    //                     </div>}
                    //                     {selectedData?.ordRemark && <div className='ksmhl-col'>
                    //                         <p><LanguageTranslator>Order Remarks</LanguageTranslator></p>
                    //                         <h3>{selectedData?.ordRemark || "-"}</h3>
                    //                     </div>}
                    //                 </div>
                    //             </div>
                    //         )
                    //     },
                    rowEndComponent: renderDraftAsnDropdown,
                    closeModal: () => checkDiscardModal()
                }}
                rowInput={{
                    rowType: "singleRow",
                    availableInputs: getInputs(),
                    inputState: { ...formData },
                    inputStateChangeFunction: (data) => { setFormData(data) },
                    errorData: { ...errorData },
                    updateErrorData: (data) => {
                        let updatedErrorData = { ...data };
                        if (formData?.contactNo === "+91" && updatedErrorData?.contactNo) {// in case of save and create,  we do not want error if there is no contact number but have +91
                            delete updatedErrorData.contactNo;
                        }
                        setErrorData(updatedErrorData)
                    }
                }}
                availableDocument={props.availableDocument || null}
                formTopExtras={!isEdit ? renderFormTopExtras : null}
                formBottomExtras={formBottomExtras()}
                footerComponent={{
                    buttons: [
                        { label: `Discard`, type: "reject", onClick: () => checkDiscardModal() },

                        // Render the Save and Draft Button
                        isDraftCreationInAsnAllowed() && {
                            label: `Save And Create New`,
                            disabled: (digiVendStore?.vendorshipCreateSrNewData?.isLoading || Object.keys(errorData || {})?.length !== 0) || poDetails?.every(item => Number(item?.newRequestedQty || "") <= 0) || (Number(selectedData?.lateDeliveryCharges ?? 0) > 0 && !lateDeliveryChargeAccepted),
                            type: "default",
                            onClick: () => saveDraftAndCreateNew(),
                            tooltip: (Number(selectedData?.lateDeliveryCharges ?? 0) > 0 && !lateDeliveryChargeAccepted) ? "Please accept the late delivery charge to proceed." : (vendConfig?.INVOICE_UPLOAD_AT_CREATE_ASN?.toLowerCase() == "true" && vendConfig?.VALIDATE_INV_AND_ASN_AMT?.toLowerCase() == "restrict") ? (+(vendConfig?.INV_AMT_TOLERANCE_AT_CREATE_ASN) && vendConfig?.INV_AMT_TOLERANCE_TYPE?.toLowerCase() !== "disable") ? setInvoiceAmountRange() :
                                // Checking if the values of the asn amount is same as invoice amount
                                Number(showCheckAmount(poDetails)) != Number(formData?.["invoiceAmount"] || "") ?
                                    `Invoice amount is not equal to  ASN amount i.e. ${showCheckAmount(poDetails)} for Requested Quantity` :
                                    "" : null
                        },
                        prevParams?.type == "CREATE_SHIPMENT_WITH_LR" && {
                            label: `Save and Continue with LR`,
                            type: "default",
                            onClick: () => handleSubmit("button", {type: "saveAndContinueWithLr"}),
                            disabled: (digiVendStore?.vendorshipCreateSrNewData?.isLoading || (isDraftCreationInAsnAllowed() ? Object.keys(draftedAsnData || {})?.length <= 0 : Object.keys(errorData || {})?.length !== 0) || (isClientHopscotch?.() && tokenData?.country.toLowerCase()==='cn' && isDraftCreationInAsnAllowed() && poDetails?.some(item => Number(item?.availableQty || 0) > 0))),
                            tooltip: isDraftCreationInAsnAllowed() ? Object.keys(draftedAsnData || {})?.length <= 0 ? "Please save your draft first." : "" : (vendConfig?.INVOICE_UPLOAD_AT_CREATE_ASN?.toLowerCase() == "true" && vendConfig?.VALIDATE_INV_AND_ASN_AMT?.toLowerCase() == "restrict") ? (+(vendConfig?.INV_AMT_TOLERANCE_AT_CREATE_ASN) && vendConfig?.INV_AMT_TOLERANCE_TYPE?.toLowerCase() !== "disable") ? setInvoiceAmountRange() : Number(showCheckAmount(poDetails)) != Number(formData?.["invoiceAmount"] || "") ? `Invoice amount is not equal to  ASN amount i.e. ${showCheckAmount(poDetails)} for Requested Quantity` : "" : null
                        },
                        {
                            label: `${isEdit ? 'Update' : 'Create'} ${vendConfig?.inspectionRequired?.toLowerCase() === "true" ? "Inspection" : "ASN"}`,
                            disabled: (
                                digiVendStore?.vendorshipCreateSrNewData?.isLoading ||
                                (isDraftCreationInAsnAllowed() ? Object.keys(draftedAsnData || {})?.length <= 0 : Object.keys(errorData || {})?.length !== 0) ||
                                (isClientHopscotch?.() && tokenData?.country.toLowerCase()==='cn' && isDraftCreationInAsnAllowed() && poDetails?.some(item => Number(item?.availableQty || 0) > 0)) ||
                                // Block direct creation until the late delivery charge is accepted.
                                // With drafted ASNs present, acceptance was already enforced at save time, so don't block.
                                (!isEdit && Object.keys(draftedAsnData || {})?.length <= 0 && Number(selectedData?.lateDeliveryCharges ?? 0) > 0 && !lateDeliveryChargeAccepted)
                                // (isClientHopscotch?.() && tokenData?.country.toLowerCase()==='cn' && !isDraftCreationInAsnAllowed() && poDetails?.some(item => (Number(item?.availableQty || 0) - Number(item?.newRequestedQty || 0) - Number(item?.newCancelledQty || 0)) > 0))
                            ),
                            type: "primary",
                            onClick: () => handleSubmit("button"),
                            tooltip: (!isEdit && Object.keys(draftedAsnData || {})?.length <= 0 && Number(selectedData?.lateDeliveryCharges ?? 0) > 0 && !lateDeliveryChargeAccepted) ? "Please accept the late delivery charge to proceed." : isDraftCreationInAsnAllowed() ? Object.keys(draftedAsnData || {})?.length <= 0 ? "Please save your draft first." : "" : (vendConfig?.INVOICE_UPLOAD_AT_CREATE_ASN?.toLowerCase() == "true" && vendConfig?.VALIDATE_INV_AND_ASN_AMT?.toLowerCase() == "restrict") ? (+(vendConfig?.INV_AMT_TOLERANCE_AT_CREATE_ASN) && vendConfig?.INV_AMT_TOLERANCE_TYPE?.toLowerCase() !== "disable") ? setInvoiceAmountRange() :
                                // Checking if the values of the asn amount is same as invoice amount
                                Number(showCheckAmount(poDetails)) != Number(formData?.["invoiceAmount"] || "") ?
                                    `Invoice amount is not equal to  ASN amount i.e. ${showCheckAmount(poDetails)} for Requested Quantity` :
                                    "" : null
                        }
                    ]?.filter(item => item?.label)
                }}
            />
            {openedModal && <ParentModal
                getParentChildProps={getParentChildProps()}
                childComponent={getChildComponent()}
            />}
        </div>
    )
}

export default CreateAsnModal